import { View, Text, Pressable, StyleSheet, TextInput, TouchableOpacity, ActivityIndicator, Icon, Icon2, Icon3 } from '../lib/react-native-compat';
import { useAtom } from 'jotai';
import moment from 'moment';
import React, { useEffect, useState, useRef } from 'react';
import { updateCOStatus, loadTeamUserData, loadTeamCostDetail, loadJobsNew, loadTeamCostDetailProjections, loadTeamOpemCommitments, pNum, fNum, saveSelectedProjectManager, loadEquipmentData, loadTeamBillings, updateUserDataArray, loadSummaryWIPArray, loadGLAccount, loadJDEValues } from '../db/company';
import { userEmailCheckAtom, dataSourceVersionAtom, isLiveVersionAtom, selectedVersionAtom, selectedJobAtom, selectedTeamAtom, dataSourceJobsAtom, projectManagerAtom, overheadDataAtom, jobUserDataAtom, selectedWIPAtom, selectedVersionLockedAtom, projectCompleteAtom, ohPercentAtom } from '../store/company';

const Projections = () => {
    const [selectedJob, setSelectedJob] = useAtom(selectedJobAtom);
    const [userEmailCheck, setUserEmailCheck] = useAtom(userEmailCheckAtom);
    const [expandCurrentProjections, setExpandCurrentProjections] = useState('')
    const [compareListJob, setCompareListJob] = useState([]) // for compare list job view
    const [versions, setVersions] = useAtom(dataSourceVersionAtom)
    const [versionInfo, setVersionInfo] = useState({})
    const [isLiveVersion, setIsLiveVersion] = useAtom(isLiveVersionAtom);
    const [selectedVersion, setSelectedVersion] = useAtom(selectedVersionAtom);
    const [selectedTeam, setSelectedTeam] = useAtom(selectedTeamAtom);
    const [jobs, setJobs] = useAtom(dataSourceJobsAtom);
    const [adminButton, setAdminButton] = useState(false)
    const [projectionsStatus, setProjectionsStatus] = useState('match'); // 'inactive' | 'mismatch' | 'match'
    const [isWipOpen, setIsWipOpen] = useState(true); // WIP week state
    const [fetchedAllJobUserData, setFetchedAllJobUserData] = useState(false)
    const [pm, setPM] = useAtom(projectManagerAtom)
    const [isFocus, setIsFocus] = useState(false)
    const [pmOptions, setPMOptions] = useState([])
    const [selectedWIP, setSelectedWIP] = useAtom(selectedWIPAtom);
    const [ohPercent, setOhPercent] = useAtom(ohPercentAtom)
    const [overheadData, setOverheadData] = useAtom(overheadDataAtom)
    const [lockedVersion, setLockedVersion] = useAtom(selectedVersionLockedAtom)
    const [jobUserData, setJobUserData] = useAtom(jobUserDataAtom)
    const [filteredJobs, setFilteredJobs] = useState([])
    const [curBudget, setCurBudget] = useState({})
    const [startDates, setStartDates] = useState({})
    const [completionDates, setCompletionDates] = useState({})
    const [mechCompleteDates, setMechCompleteDates] = useState({})
    const [physicalComplete, setPhysicalComplete] = useState({})
    const [actualCost, setActualCost] = useState({})
    const [actualOverhead, setActualOverhead] = useState({})
    const [openCommitments, setOpenCommitments] = useState({})
    const [ETC, setETC] = useState({})
    const [EAC, setEAC] = useState({})
    const [jobProfit, setJobProfit] = useState({})
    const [jobProfitPerc, setJobProfitPerc] = useState({})
    const [jobPrevWIP, setJobPrevWIP] = useState({})
    const [equipmentUserData, setEquipmentUserData] = useState({})
    const [labor, setLabor] = useState({})
    const [laborCostType, setLaborCostType] = useState({})
    const [equipmentCostType, setEquipmentCostType] = useState({})
    const [equipmentPhased, setEquipmentPhased] = useState({})
    const [materials, setMaterials] = useState({})
    const [rentals, setRentals] = useState({})
    const [subcontractors, setSubcontractors] = useState({})
    const [other, setOther] = useState({})
    const [contingency, setContingency] = useState({})
    const [incentive, setIncentive] = useState({})
    const [total, setTotal] = useState({})
    const [projectComplete, setProjectComplete] = useAtom(projectCompleteAtom)
    const [grossMargin, setGrossMargin] = useState({})
    const [grossMarginPerc, setGrossMarginPerc] = useState({})
    const [backlog, setBacklog] = useState({})

    const [prevContingency, setPrevContingency] = useState({})
    const [costPercent, setCostPercent] = useState({})
    const [actualHours, setActualHours] = useState({})
    const [hoursETC, setHoursETC] = useState({})
    const [mostRecentBill, setMostRecentBill] = useState({})
    const [earnedRevenue, setEarnedRevenue] = useState({})
    const [billings, setBillings] = useState({})
    const [overUnderBilled, setOverUnderBilled] = useState({})
    const [remainingToBill, setRemainingToBill] = useState({})
    const [expandCosts, setExpandCosts] = useState(false)
    const [expandBills, setExpandBills] = useState(false)
    const [earnedRevenueRows, setEarnedRevenueRows] = useState({})
    const [etcOverhead, setETCOverhead] = useState({})
    const [backlogFiltered, setBacklogFiltered] = useState([])
    const [backlogFilteredImage, setBacklogFilteredImage] = useState([])
    const sectionRefs = useRef([])
    const [highlightedJob, setHighlightedJob] = useState({})
    const [totalBudget, setTotalBudget] = useState(0)
    const [totalEAC, setTotalEAC] = useState(0)
    const [totalCost, setTotalCost] = useState(0)
    const [totalJobProfit, setTotalJobProfit] = useState(0)
    const [totalJobProfitPercent, setTotalJobProfitPercent] = useState(0)
    const [totalGrossMargin, setTotalGrossMargin] = useState(0)
    const [totalGrossMarginPercent, setTotalGrossMarginPercent] = useState(0)
    const [totalContingency, setTotalContingency] = useState(0)
    const [totalPrevContingency, setTotalPrevContingency] = useState(0)
    const [totalBacklog, setTotalBacklog] = useState(0)
    const [totalJobPerformanceChange, setTotalJobPerformanceChange] = useState(0)
    const [totalPrevWIP, setTotalPrevWIP] = useState(0)
    const [totalOverUnderBilled, setTotalOverUnderBilled] = useState(0)

    const [etcPieces, setEtcPieces] = useState({})
    const [phaseEtcPieces, setPhaseEtcPieces] = useState({})
    const [laborPieces, setLaborPieces] = useState({})
    const [laborPhasedPieces, setLaborPhasedPieces] = useState({})
    const [equipmentPieces, setEquipmentPieces] = useState({})
    const [equipmentPhasedPieces, setEquipmentPhasedPieces] = useState({})
    const [openCommitmentsPieces, setOpenCommitmentsPieces] = useState({})
    const [projectionCost, setProjectionCost] = useState([])
    const [contingencyPieces, setContingencyPieces] = useState({})
    const [projectionRows, setProjectionRows] = useState([])
    const [excelProjectionRows, setExcelProjectionRows] = useState([])
    const fileInput = useRef(null);
    const [file, setFile] = useState(null);


    const [eacLabor, setEACLabor] = useState({})
    const [eacEquipment, setEACEquipment] = useState({})
    const [eacMaterials, setEACMaterials] = useState({})
    const [eacRentals, setEACRentals] = useState({})
    const [eacSubcontractors, setEACSubcontractors] = useState({})
    const [eacOther, setEACOther] = useState({})
    const [eacContingency, setEACContingency] = useState({})
    const [equipRates, setEquipRates] = useState({})
    const [projectionDetails, setProjectionDetails] = useState([])
    const [failedUploads, setFailedUploads] = useState([])
    const [glCombinations, setGLCombinations] = useState({})
    const [combinationDropdown, setCombinationDropdown] = useState({})
    const [notFoundList, setNotFoundList] = useState([])
    const [neededProjections, setNeededProjections] = useState([])
    const [jdeValues, setJDEValues] = useState([])
    const [glValues, setGlValues] = useState([])
    const [showNotFoundList, setShowNotFoundList] = useState(false)
    const [notFoundListCount, setNotFoundListCount] = useState(0)
    const [notFoundJobs, setNotFoundJobs] = useState({})
    const [compareList, setCompareList] = useState([])
    const [highLevelCompareList, setHighLevelCompareList] = useState({})
    const [jdeValuesLoading, setJDEValuesLoading] = useState(true)
    const [budgetStatus, setBudgetStatus] = useState('mismatch'); // 'mismatch' | 'loading' | 'saved'
    const [savedValues, setSavedValues] = useState({})
    const [postProjectionsLoading, setPostProjectionsLoading] = useState(false)
    const [submitProjectionsLoading, setSubmitProjectionsLoading] = useState(false)


    const s = StyleSheet.create({
        container: {
            padding: 16,
            gap: 16,
        },
        cellNew: {
            height: 32,
            width: 100,
            borderWidth: 1,
            borderColor: '#aeadaf',
            padding: 6,
            justifyContent: 'center',
        },
        iconButton: {
            flexDirection: 'row',
            alignItems: 'center',
            gap: 6,
        },
        inactive: {
            opacity: 0.4,
        },
        buttonText: {
            fontSize: 11,
        },
        syncBox: {
            backgroundColor: '#d4f6d1',
            padding: 10,
            borderRadius: 8,
            borderWidth: 1,
            borderColor: '#7cc67f',
        },
        syncText: {
            fontSize: 14,
            flexDirection: 'row'
        },
        cell: {
            height: 32,
            borderWidth: 1,
            borderColor: '#aeadaf',
            padding: 4,
            textAlign: 'center',
        },
        dropdown: {
            height: 32,
            width: 200,
            borderColor: 'white',
            paddingHorizontal: 8,
            borderColor: '#aeadaf',
            borderWidth: 1,
        },
        placeholderStyle: {
            fontSize: 16,
            fontWeight: '300',
        },
        selectedTextStyle: {
            fontSize: 16,
            color: 'black'
        },
        placeholderStyle: {
            fontSize: 16,
            fontWeight: '300',

        },
        selectedTextStyle: {
            fontSize: 16,
            color: 'black'
        },
        cellOld: {
            height: 20,
            borderWidth: 1,
            borderColor: '#aeadaf',
            padding: 2,
            lineHeight: 16,
            textWrap: 'nowrap',
            overflow: 'hidden',
            textAlign: 'right'
        },
        cellt: {
            borderWidth: 1,
            borderColor: '#aeadaf',
            padding: 2,
            paddingBottom: 3,
            textAlign: 'right',
            fontSize: 12
        },
        celll: {
            height: 20,
            borderWidth: 1,
            borderColor: '#aeadaf',
            padding: 2,
            textWrap: 'nowrap',
            overflow: 'hidden',
            textAlign: 'left',
            fontSize: 12
        }
    });

    const allowed = {
        "steven.horman@strikeusa.com": true,
        "seth.bailey@strikeusa.com": true,
        "gerald.buckmiller@strikeusa.com": true,
        "cameron.pitre@strikeusa.com": true,
        "meghan.marasco-robertson@crossfire-llc.com": true,
        "leah.jenkins@strikeusa.com": true,
        "joshua.daley@strikeusa.com": true,
        "ryan.hosey@strikeusa.com": true,
        "eleah@crossfire-llc.com": true,
        "aeron.griggs@strikeusa.com": true
    }

    useEffect(() => {
        if (expandCurrentProjections) {
            const filteredCompareList = compareList.filter(row => row.jobId === expandCurrentProjections);
            setCompareListJob(filteredCompareList);
        }
    }, [expandCurrentProjections, compareList]);

    useEffect(() => {
        versions && versions.length > 0 && setVersionInfo(versions.find(v => v.Version_GUID === selectedVersion))
    }, [versions, selectedVersion]);


    useEffect(() => {
        let filtered = []
        filtered = jobs ? jobs.filter(a => a.Cat_Code_BU_27 == selectedTeam).filter(a => a.Cat_Code_BU_08 != 'T&M') : []
        if (adminButton) {
            filtered = jobs ? jobs.filter(a => a.Cat_Code_BU_08 != 'T&M') : []
            setFetchedAllJobUserData(false)
        }
        const uniquePMs = filtered && filtered.length ? [...new Set(filtered.map(job => job.Project_Manager_Name))] : []
        const pmOptionsList = uniquePMs.map(pm => ({ label: pm, value: pm }));
        setPMOptions(pmOptionsList);
        if (/*!pm*/true) {
            filtered.sort((a, b) => {
                // if (a.Project_Manager_Name < b.Project_Manager_Name) return -1;
                // if (a.Project_Manager_Name > b.Project_Manager_Name) return 1;
                if (a.BU_ID < b.BU_ID) return -1;
                if (a.BU_ID > b.BU_ID) return 1;
                return 0;
            });
        } else {
            filtered = filtered.filter(job => job.Project_Manager_Name === pm)
        }
        // filtered = filtered.map(job => ({
        //     ...job,
        //     compare: highLevelCompareList[job.BU_ID] || {}
        // }));
        if (filteredJobs && !filtered.length) {
            console.log('no jobs found')
        } else {
            console.log('set job list')
            if (filtered.length > filteredJobs.length) {
                setFetchedAllJobUserData(false)
                setFilteredJobs(filtered)
            }
        }
    }, [jobs])

    useEffect(() => {
        console.log('job list update', filteredJobs)
    }, [filteredJobs])


    //------------

    const buildCSVContent = () => {
        const jobIds = filteredJobs.map(j => j.BU_ID);
        const projectionsToSync = neededProjections.filter(row => jobIds.includes(row.jobId));
        if (!projectionsToSync.length) return null;

        const glDate = moment(selectedWIP?.Version_Start_DateTime).add(1, 'month').endOf('month').format('M/D/YYYY');
        const fy = moment(selectedWIP?.Version_Start_DateTime).add(1, 'month').format('YY');
        const csvHeaders = 'AccountNbr,EACAmount,Units,User,Remark,GLDate,FY';
        const csvRows = projectionsToSync.map(row => {
            const accountNbr = `${row.jobId}.${row.costType}.${row.phaseCode}`;
            const amount = pNum(row.value);
            return `${accountNbr},${amount},1,154045,Fusion EAC Upload,${glDate},${fy}`;
        });
        return [csvHeaders, ...csvRows].join('\n');
    }

    // Step 1: Generate CSV and download it to the JDE input file path
    const generateCSV = () => {
        setSubmitProjectionsLoading(true);
        try {
            const csvContent = buildCSVContent();
            if (!csvContent) {
                console.log('No projections to export');
                setSubmitProjectionsLoading(false);
                return;
            }

            const fileName = `FusionEAC_${moment().format('YYYYMMDD')}`;

            // Create a blob and trigger browser download
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            link.click();
            URL.revokeObjectURL(url);

            console.log(`CSV generated: ${fileName} (save to \\\\thepatecompanies.com\\jdefiles\\JDE-PY\\EAC\\InputFile)`);
        } catch (err) {
            console.log('Error generating CSV:', err.message);
        } finally {
            setSubmitProjectionsLoading(false);
        }
    }

    // Step 2: Call the JDE Bulk Batch Upload orchestration after CSV is in place
    const runBulkUpload = async () => {
        setPostProjectionsLoading(true);
        try {
            const orchUrl = process.env.NODE_ENV === 'production'
                ? 'https://jdeorch.strikeusa.com:443/jderest/orchestrator/STR_ORCH_FusionEAC_BulkBatchUpload'
                : 'https://jdeorchtest.strikeusa.com:443/jderest/orchestrator/STR_ORCH_FusionEAC_BulkBatchUpload';
            const orchAuth = process.env.NODE_ENV === 'production'
                ? 'Basic MTQ4Njk1Oks2b1chKmVJZ216dDZWd2Y='
                : 'Basic MTQ4Njk0OlV4ZTBUbWotV1Q5OGJGQXE=';

            const response = await fetch(orchUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': orchAuth
                }
            });

            const data = await response.json();
            if (data?.jde__status === 'SUCCESS') {
                console.log('Bulk EAC upload successful:', data);
                const jobIds = filteredJobs.map(j => j.BU_ID);
                const newSavedValues = { ...savedValues };
                jobIds.forEach(id => { newSavedValues[id] = true; });
                setSavedValues(newSavedValues);
            } else {
                console.log('Bulk EAC upload response:', data);
            }
        } catch (err) {
            console.log('Error calling bulk upload orchestration:', err.message);
        } finally {
            setPostProjectionsLoading(false);
        }
    }

    const findCombinations = async (data = null) => {
        const combinations = {}
        const combinationDropdown = {}
        const loopValues = data ? data : glValues
        if (glValues?.length) {
            loopValues.forEach((d) => {
                if (!combinations[d.BU_ID]) {
                    combinations[d.BU_ID] = {}
                    combinationDropdown[d.BU_ID] = {}
                }

                if (!combinations[d.BU_ID][d.Object_Account_ID]) {
                    combinations[d.BU_ID][d.Object_Account_ID] = {}
                    combinationDropdown[d.BU_ID][d.Object_Account_ID] = []
                }

                if (!combinations[d.BU_ID][d.Object_Account_ID][d.Subsidiary]) {
                    combinations[d.BU_ID][d.Object_Account_ID][d.Subsidiary] = true
                    combinationDropdown[d.BU_ID][d.Object_Account_ID].push({ label: d.Subsidiary, value: d.Subsidiary })
                }
            })
            //console.log('combinations', combinations, glValues.length, projectionRows.length)
            const notFound = []
            const notFoundJobs = {}
            projectionRows.forEach((row) => {
                if (row.costType != '60900' && !combinations[row.jobId]?.[row.costType]?.[row.phaseCode]) {
                    notFound.push(row)
                    if (!notFoundJobs[row.jobId]) {
                        notFoundJobs[row.jobId] = true
                    }
                }
            })
            //console.log('not found', notFound)
            setNotFoundListCount(notFound.length)
            setNotFoundList(notFound)
            setNotFoundJobs(notFoundJobs)
            setGLCombinations(combinations)
            setCombinationDropdown(combinationDropdown)
        }
    }

    const handlePhaseChange = (item, newPhase) => {
        const newProjections = [...neededProjections];
        const existingCombination = neededProjections.find(
            (existingItem) =>
                existingItem.jobId === item.jobId &&
                existingItem.costType === item.costType &&
                existingItem.phaseCode === newPhase
        );
        setNeededProjections(() => {
            if (existingCombination) {
                existingCombination.value = pNum(existingCombination.value) + pNum(item.value);
                return newProjections.filter(
                    (existingItem) =>
                        !(
                            existingItem.jobId === item.jobId &&
                            existingItem.costType === item.costType &&
                            existingItem.phaseCode === item.phaseCode
                        )
                ).concat(existingCombination);
            } else {
                return newProjections.filter(
                    (existingItem) =>
                        !(
                            existingItem.jobId === item.jobId &&
                            existingItem.costType === item.costType &&
                            existingItem.phaseCode === item.phaseCode
                        )
                ).concat({ ...item, phaseCode: newPhase });
            }
        });
    }

    useEffect(() => {
        if (glValues?.length && projectionRows.length) {
            findCombinations()
        }
    }, [glValues, projectionRows])

    useEffect(() => {
        if (filteredJobs.length) {
            const jobIds = filteredJobs.map(j => j.BU_ID)

            fetch('http://localhost:3000/projections', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(data => {
                    setJDEValues(data?.data);
                    setJDEValuesLoading(false)

                    console.log('jde data', data?.data)
                    const jobData = data?.data?.filter(item => item.Job_ID?.trim() === '54024064');
                    if (jobData) {
                        const jobObject = { ...jobData };
                        console.log('Job 54024064:', jobObject);
                    }

                })
                .catch(error => {
                    console.error('Error fetching projections:', error);
                });


            // fetch('http://localhost:3000/projectionsTwo', {
            //     method: 'GET',
            //     headers: {
            //         'Content-Type': 'application/json'
            //     }
            // })
            //     .then(response => response.json())
            //     .then(data => {
            //         //console.log('Projections data:', data?.data.length);
            //         setJDEValues(data?.data);

            //     })
            //     .catch(error => {
            //         console.error('Error fetching projections:', error);
            //     });

            // loadJDEValues({ ids: jobIds }).then((data) => {
            //     //if (data?.data?.length > jdeValues?.length) {
            //     console.log('JDE Values data:', data?.data.length);
            //     setJDEValues(data?.data)
            //     setJDEValuesLoading(false)
            //     //}
            // })

            loadGLAccount({ ids: jobIds }).then((data) => {
                console.log('GL Account data:', data?.data.length);
                //if (data?.data?.length > glValues?.length) {
                setGlValues(data?.data)
                //}
            })
        }
    }, [filteredJobs])

    useEffect(() => {
        const fJDE = (nStr) => {
            let a = ''
            numberStr = nStr ? nStr + '' : ''
            if (!numberStr) return 0; // Handle empty input

            if (numberStr.length === 1) {
                a = "0.0" + numberStr; // Convert "7" to "0.07"
            } else if (numberStr.length === 2) {
                a = "0." + numberStr; // Convert "99" to "0.99"
            } else if (numberStr) {
                a = numberStr.slice(0, -2) + '.' + numberStr.slice(-2);
            }
            return isNaN(pNum(a)) ? 0 : pNum(a);
        }

        //if (jdeValues?.length) {
        const period = selectedWIP?.Version_Start_DateTime
            ? moment(selectedWIP.Version_Start_DateTime).add(1, 'month').month()
            : 0;
        const currentValues = {}
        jdeValues && jdeValues?.forEach((d) => {
            const jobId = d.Job_ID.trim();
            const costType = d.Cost_Type.trim();
            const phaseCode = d.Cost_Code.trim();
            if (!currentValues[jobId]) {
                currentValues[jobId] = {}
            }
            if (!currentValues[jobId][costType]) {
                currentValues[jobId][costType] = {}
            }
            if (!currentValues[jobId][costType][phaseCode]) {
                //if(jobId == '54024033' && costType == '41000' && phaseCode == '990000') console.log('row 1', d, fJDE(d.PRDP), fJDE(d.PRD1), fJDE(d.PRD2), fJDE(d.PRD3)) //, fJDE(d.PRD4), fJDE(d.PRD5), fJDE(d.PRD6), fJDE(d.PRD7), fJDE(d.PRD8), fJDE(d.PRD9))
                //currentValues[jobId][costType][phaseCode] = 
                //    Array.from({ length: period + 1 }, (_, i) => fJDE(d[`PRD${i}`])).reduce((sum, value) => sum + value, 0);
                currentValues[jobId][costType][phaseCode] = fJDE(d.PRDP) + fJDE(d.PRD1) + fJDE(d.PRD2) + fJDE(d.PRD3) + fJDE(d.PRD4) + fJDE(d.PRD5) + fJDE(d.PRD6) + fJDE(d.PRD7) + fJDE(d.PRD8)// + fJDE(d.PRD9)
                //d.PRD1 + d.PRD2 + d.PRD3 + d.PRD4 + d.PRD5 + d.PRD6 + d.PRD7 + d.PRD8 + d.PRD9
                //fJDE(d.PRD1) + fJDE(d.PRD2) + fJDE(d.PRD3) + fJDE(d.PRD4) + fJDE(d.PRD5) + fJDE(d.PRD6) + fJDE(d.PRD7) + fJDE(d.PRD8) + fJDE(d.PRD9)
            } else {
                //if(jobId == '54024033' && costType == '41000' && phaseCode == '990000') console.log('row 2', d, fJDE(d.PRDP), fJDE(d.PRD1), fJDE(d.PRD2), fJDE(d.PRD3),fJDE(d.PRDP) + fJDE(d.PRD1) + fJDE(d.PRD2) + fJDE(d.PRD3)) //, fJDE(d.PRD4), fJDE(d.PRD5), fJDE(d.PRD6), fJDE(d.PRD7), fJDE(d.PRD8), fJDE(d.PRD9))
                //currentValues[jobId][costType][phaseCode] = fNum(pNum(currentValues[jobId][costType][phaseCode]) + (fJDE(d.PRDP) + fJDE(d.PRD1) + fJDE(d.PRD2) + fJDE(d.PRD3)))// + fJDE(d.PRD4) + fJDE(d.PRD5) + fJDE(d.PRD6) + fJDE(d.PRD7) + fJDE(d.PRD8) + fJDE(d.PRD9)
            }
        })

        //console.log('current values', currentValues)
        const discrepancies = [];
        // const projectionRowsCopy = [{
        //     jobId: '10111005',
        //     costType: '52200',
        //     phaseCode: '195101',
        //     value: '54000'
        // }, ...projectionRows]

        projectionRows.forEach((row, index) => {
            const { jobId, costType, phaseCode, value } = row;
            const currentValue = currentValues[jobId]?.[costType]?.[phaseCode];
            //if (currentValue == '44,447.99' || (costType == '52100' && phaseCode == '100101')) console.log('row 1', row, currentValue, value)

            if (value == 0 && !currentValue) {
                ////console.log('not found add', row)
                //if (index == 0) console.log('row 2', currentValue)
                //discrepancies.push(row);
            } else if (!currentValue || currentValue != value) {
                //if (index == 0) console.log('row 3', currentValue)
                discrepancies.push(row);
            }
        });

        //console.log('discrepancies 1', discrepancies.filter(d => d.jobId == '54025036').length)

        const newRows = [];
        const compareListLocal = [];
        Object.keys(currentValues).forEach((jobId) => {
            Object.keys(currentValues[jobId]).forEach((costType) => {
                Object.keys(currentValues[jobId][costType]).forEach((phaseCode) => {
                    const row = {
                        jobId,
                        costType,
                        phaseCode,
                        value: pNum(currentValues[jobId][costType][phaseCode])
                    }

                    const exists = projectionRows.find(row => row.jobId === jobId && row.costType === costType && row.phaseCode === phaseCode);
                    if (exists) {
                        row.projectionValue = exists?.value
                        //console.log('already exists',costType, phaseCode, pNum(currentValues[jobId][costType][phaseCode]) )
                    }
                    if (!exists) {
                        // if (pNum(currentValues[jobId][costType][phaseCode]) == 9.09) {
                        //     //console.log('9.09 row', row)
                        // } else {
                        //     //console.log('not 9.09 row', row)
                        // }
                        const newRow = {
                            jobId,
                            costType,
                            phaseCode,
                            value: '0'
                        };
                        discrepancies.push(newRow);
                        newRows.push(newRow);
                    }
                    compareListLocal.push(row)
                });
            });
        });

        projectionRows.forEach((row) => {
            const exists = compareListLocal.find(compareRow =>
                compareRow.jobId === row.jobId &&
                compareRow.costType === row.costType &&
                compareRow.phaseCode === row.phaseCode
            );
            if (!exists) {
                compareListLocal.push({
                    jobId: row.jobId,
                    costType: row.costType,
                    phaseCode: row.phaseCode,
                    value: '',
                    projectionValue: row.value
                })
            } else {
                exists.projectionValue = row.value
            }
        });

        //console.log('new rows', newRows)
        //console.log('compare list', compareListLocal)
        setCompareList(compareListLocal.sort((a, b) => {
            if (a.costType > b.costType) {
                return 1
            }
            if (a.costType < b.costType) {
                return -1
            }
        }))

        const discrepanciesWithinTolerance = [];
        compareListLocal.forEach(row => {
            const difference = Math.abs(pNum(row.value) - pNum(row.projectionValue));
            if (difference > 0.01) {
                discrepanciesWithinTolerance.push({
                    jobId: row.jobId,
                    costType: row.costType,
                    phaseCode: row.phaseCode,
                    prevValue: row.value,
                    value: row.projectionValue ? row.projectionValue : '0.00',
                });
            }
        });
        //console.log('Discrepancies within tolerance:', discrepanciesWithinTolerance.filter(d => d.jobId == '54025036'))


        const highLevelCompare = {}
        const addToHighLevelCompare = (jobId, costType, phaseCode, value, projectionValue) => {
            const existingEntry = highLevelCompare[jobId];

            if (existingEntry) {
                if (phaseCode == '101101') {
                    existingEntry.contingency += value;
                    existingEntry.contingencyProjection += projectionValue;
                } else if (costType.startsWith('51')) {
                    existingEntry.labor += value;
                    //if (jobId == '50424040') //console.log('labor', projectionValue)
                    existingEntry.laborProjection += projectionValue;
                } else if (costType.startsWith('52')) {
                    existingEntry.equipment += value;
                    existingEntry.equipmentProjection += projectionValue;
                } else if (costType.startsWith('53')) {
                    existingEntry.materials += value;
                    existingEntry.materialsProjection += projectionValue;
                } else if (costType.startsWith('54')) {
                    existingEntry.subcontractors += value;
                    existingEntry.subcontractorsProjection += projectionValue;
                } else if (costType.startsWith('55') || costType.startsWith('56') || costType.startsWith('57')) {
                    existingEntry.other += value;
                    existingEntry.otherProjection += projectionValue;
                } else if (costType.startsWith('60900')) { // Overhead
                    existingEntry.overhead += value;
                    existingEntry.overheadProjection += projectionValue;
                } else if (costType.startsWith('41')) { // Revenue
                    existingEntry.revenue += value;
                    existingEntry.revenueProjection += projectionValue;
                }

            } else {
                highLevelCompare[jobId] = {
                    jobId,
                    labor: costType.startsWith('51') && phaseCode != '101101' ? value : 0,
                    equipment: costType.startsWith('52') && phaseCode != '101101' ? value : 0,
                    materials: costType.startsWith('53') && phaseCode != '101101' ? value : 0,
                    subcontractors: costType.startsWith('54') && phaseCode != '101101' ? value : 0,
                    other: (costType.startsWith('55') || costType.startsWith('56') || costType.startsWith('57')) && phaseCode != '101101' ? value : 0,
                    laborProjection: costType.startsWith('51') && phaseCode != '101101' ? projectionValue : 0,
                    equipmentProjection: costType.startsWith('52') && phaseCode != '101101' ? projectionValue : 0,
                    materialsProjection: costType.startsWith('53') && phaseCode != '101101' ? projectionValue : 0,
                    subcontractorsProjection: costType.startsWith('54') && phaseCode != '101101' ? projectionValue : 0,
                    otherProjection: (costType.startsWith('55') || costType.startsWith('56') || costType.startsWith('57')) && phaseCode != '101101' ? projectionValue : 0,
                    contingency: phaseCode == '101101' ? value : 0,
                    contingencyProjection: phaseCode == '101101' ? projectionValue : 0,
                    revenue: costType.startsWith('41') ? -pNum(value) : 0,
                    revenueProjection: costType.startsWith('41') ? -pNum(projectionValue) : 0,
                    overhead: costType.startsWith('60900') ? value : 0,
                    overheadProjection: costType.startsWith('60900') ? projectionValue : 0
                };
            }
        };

        compareListLocal.forEach(row => {
            addToHighLevelCompare(row.jobId, row.costType, row.phaseCode, pNum(row.value), pNum(row.projectionValue));
        });

        //console.log('High Level Compare:', highLevelCompare);
        //console.log('projection rows', projectionRows)
        setHighLevelCompareList(highLevelCompare);
        //console.log('discrepancies', discrepancies.filter(d => d.jobId == '54024064'))
        setNeededProjections(discrepanciesWithinTolerance)
        //}
    }, [jdeValues, projectionRows])

    useEffect(() => {
        const jobIds = filteredJobs.map(j => j.BU_ID)
        const overUnderBilled = {}
        const remainingToBill = {}
        jobIds.forEach((job) => {
            overUnderBilled[job] = pNum(billings[job]) - pNum(earnedRevenue[job])
            remainingToBill[job] = pNum(curBudget[job]) - pNum(billings[job])
        })
        setOverUnderBilled(overUnderBilled)
        setRemainingToBill(remainingToBill)
    }, [billings, earnedRevenue, curBudget, filteredJobs])

    useEffect(() => {
        if (selectedTeam) {
            setOhPercent(overheadData[selectedTeam] ? overheadData[selectedTeam] : '')
        }
    }, [selectedTeam, overheadData])

    useEffect(() => {
        const earnedRevenue = {}
        ////console.log('earned revenue rows', earnedRevenueRows)
        earnedRevenueRows && Object.keys(earnedRevenueRows).forEach((job) => {
            earnedRevenue[job] = isNaN(pNum(earnedRevenueRows[job])) ? 0 : pNum(earnedRevenueRows[job]) * -1
        })


        const ohETC = {}
        const jobIds = filteredJobs.map(j => j.BU_ID)
        const ohTeamPercent = {}
        filteredJobs.forEach(job => {
            ohTeamPercent[job.BU_ID] = overheadData[job.Cat_Code_BU_27] ? overheadData[job.Cat_Code_BU_27] : ''
        })

        jobIds.forEach((job) => {
            const ohPer = ohTeamPercent[job] ? pNum(ohTeamPercent[job]) : 0
            const oh = curBudget[job] ? earnedRevenueRows[job] ? (pNum(curBudget[job]) + pNum(earnedRevenueRows[job])) * ohPer / 100 : pNum(curBudget[job]) * ohPer / 100 : ''
            const ohFormatted = oh < 0 ? '' : isNaN(pNum(oh)) ? 0 : pNum(oh)
            ////console.log('oh per', job, ohPer, pNum(earnedRevenueRows[job]), pNum(curBudget[job]), oh)
            //if (job == '10124011')//console.log('oh >>', job, curBudget[job], earnedRevenue[job], ohPer, oh)
            ohETC[job] = ohFormatted
        })
        ////console.log('oh etc', ohETC)
        //if wrong check wip date for earned rev
        setETCOverhead(ohETC)
    }, [earnedRevenueRows, overheadData, curBudget])

    useEffect(() => {
        ////console.log('here in not loading')
        if (!fetchedAllJobUserData && filteredJobs?.length > 0) {
            ////console.log('here in loading')
            setFetchedAllJobUserData(true)
            const chOrValues = {}
            const dayZeroValues = {}
            const mechanicallyCompleteDates = {}
            const startDates = {}
            const completionDates = {}
            const physicalComplete = {}

            const jobIds = filteredJobs.map(j => j.BU_ID)
            console.log('job ids', jobIds)
            const phasedEquipment = {}
            const phasedLabor = {}
            const laborValues = {}
            const equipmentValues = {}
            const contingData = {}
            const etcValues = {}
            const etcValuesPieces = {}
            const highlightedJob = {}
            const w = {}

            loadEquipmentData({ forecastGuid: selectedVersion }).then((data) => {
                const rData = {}
                data?.data.forEach((d) => {
                    if (d?.Forecast_Tab === 'Equipment') {
                        if (rData[d?.Forecast_Row_ID]) {
                            rData[d?.Forecast_Row_ID][d.Forecast_Field_Name] = d.Forecast_Value
                        } else {
                            rData[d?.Forecast_Row_ID] = {
                                id: d?.Forecast_Row_ID,
                                [d.Forecast_Field_Name]: d.Forecast_Value
                            }
                        }
                    }
                })

                const rates = {}
                Object.values(rData).forEach((row, index) => {
                    rates[row['Equipment Tier']] = row['Current Hourly Billing Rate']
                })
                ////console.log('rates', rates)
                setEquipRates(rates)
            })

            ////console.log('etc values', etcValues);

            loadTeamUserData({ ids: jobIds, forecastGuid: selectedVersion }).then((data) => {
                ////console.log('user data', data);
                data?.data?.forEach((d) => {
                    if (d?.Forecast_Tab === 'Change Order') {
                        if (chOrValues[d?.BU_ID]) {
                            chOrValues[d?.BU_ID][d?.Forecast_User_Data_GUID || d?.Forecast_Row_ID] = { ...d, [d.Cost_Type]: d.Value_Amount, id: d.Row_Label }
                        } else {
                            chOrValues[d?.BU_ID] = {
                                [d?.Forecast_User_Data_GUID || d?.Forecast_Row_ID]: { ...d, [d.Cost_Type]: d.Value_Amount, id: d.Row_Label }
                            }
                        }
                    }

                    if (d?.Forecast_Tab === 'Day Zero Budget') {
                        if (dayZeroValues[d?.BU_ID] && dayZeroValues[d?.BU_ID][d?.Forecast_Row_ID]) {
                            dayZeroValues[d?.BU_ID][d?.Forecast_Row_ID] = d
                        } else if (dayZeroValues[d?.BU_ID]) {
                            dayZeroValues[d?.BU_ID][d?.Forecast_Row_ID] = d
                        } else {
                            dayZeroValues[d?.BU_ID] = {
                                [d?.Forecast_Row_ID]: d
                            }
                        }
                    }

                    if (d?.Forecast_Tab === 'All' || d?.Forecast_Tab === 'Forecast' || d?.Forecast_Tab === 'Set Dates') {
                        if (d?.Forecast_Field_Name === 'mechanicallyComplete') {
                            mechanicallyCompleteDates[d?.BU_ID] = d?.Forecast_Value ? moment(d?.Forecast_Value).format('M/D/YYYY') : ''
                        } else if (d?.Forecast_Field_Name === 'startDateActual') {
                            startDates[d?.BU_ID] = d?.Forecast_Value ? moment(d?.Forecast_Value).format('M/D/YYYY') : ''
                        } else if (d?.Forecast_Field_Name === 'completionDateForecast') {
                            completionDates[d?.BU_ID] = d?.Forecast_Value ? moment(d?.Forecast_Value).format('M/D/YYYY') : ''
                        } else if (d?.Forecast_Field_Name === 'physicalComplete') {
                            physicalComplete[d?.BU_ID] = d?.Forecast_Value
                        }
                    }

                    if (d?.Forecast_Tab === 'Burn Tool Labor') {
                        if (laborValues[d?.BU_ID]) {
                            laborValues[d?.BU_ID][d?.Forecast_Row_ID] = d
                        } else {
                            laborValues[d?.BU_ID] = {
                                [d?.Forecast_Row_ID]: d
                            }
                        }
                    }

                    if (d?.Forecast_Tab === 'Burn Tool Equipment') {
                        if (equipmentValues[d?.BU_ID]) {
                            equipmentValues[d?.BU_ID][d?.Forecast_Row_ID] = d
                        } else {
                            equipmentValues[d?.BU_ID] = {
                                [d?.Forecast_Row_ID]: d
                            }
                        }
                    }

                    if (d?.Forecast_Tab === 'Burn Tool Equipment Phased') {
                        if (phasedEquipment[d?.BU_ID]?.[d?.Forecast_Row_ID]) {
                            phasedEquipment[d?.BU_ID][d?.Forecast_Row_ID] = {
                                id: d?.Forecast_Row_ID,
                                ...d
                            }
                        } else if (phasedEquipment[d?.BU_ID]) {
                            phasedEquipment[d?.BU_ID][d?.Forecast_Row_ID] = {
                                id: d?.Forecast_Row_ID,
                                ...d
                            }
                        } else {
                            phasedEquipment[d?.BU_ID] = {
                                [d?.Forecast_Row_ID]: {
                                    id: d?.Forecast_Row_ID,
                                    ...d
                                }
                            }
                        }
                    }

                    if (d?.Forecast_Tab === 'Burn Tool Labor Phased') {
                        if (phasedLabor[d?.BU_ID]?.[d?.Forecast_Row_ID]) {
                            phasedLabor[d?.BU_ID][d?.Forecast_Row_ID] = {
                                id: d?.Forecast_Row_ID,
                                ...d
                            }
                        } else if (phasedLabor[d?.BU_ID]) {
                            phasedLabor[d?.BU_ID][d?.Forecast_Row_ID] = {
                                id: d?.Forecast_Row_ID,
                                ...d
                            }
                        } else {
                            phasedLabor[d?.BU_ID] = {
                                [d?.Forecast_Row_ID]: {
                                    id: d?.Forecast_Row_ID,
                                    ...d
                                }
                            }
                        }
                    }

                    if (d?.Forecast_Tab === 'Contingency') {
                        if (contingData[d?.BU_ID]?.[d?.Forecast_Row_ID]) {
                            contingData[d?.BU_ID][d?.Forecast_Row_ID][d.Forecast_Field_Name] = d.Forecast_Value
                        } else if (contingData[d?.BU_ID]) {
                            contingData[d?.BU_ID][d?.Forecast_Row_ID] = {
                                id: d?.Forecast_Row_ID,
                                [d.Forecast_Field_Name]: d.Forecast_Value,
                                Cost_Type: d.Cost_Type,
                                Cost_Code: d.Cost_Code ? d.Cost_Code : '100105'
                            }
                        } else {
                            contingData[d?.BU_ID] = {
                                [d?.Forecast_Row_ID]: {
                                    id: d?.Forecast_Row_ID,
                                    [d.Forecast_Field_Name]: d.Forecast_Value,
                                    Cost_Type: d.Cost_Type,
                                    Cost_Code: d.Cost_Code ? d.Cost_Code : '100105'
                                }
                            }
                        }
                    }

                    // Match bidForecast: count every saved ETC row regardless of which tab wrote it
                    if (d?.Cost_Type && d?.Forecast_Field_Name == 'etc' && (!d?.Cost_Code || d?.Cost_Code != '101101')) {
                        if (etcValues[d?.BU_ID]?.[d?.Cost_Type]) {
                            etcValues[d?.BU_ID][d?.Cost_Type] = etcValues[d?.BU_ID][d?.Cost_Type] + pNum(d?.Value_Amount)
                        } else if (etcValues[d?.BU_ID]) {
                            etcValues[d?.BU_ID][d?.Cost_Type] = pNum(d?.Value_Amount)
                        } else {
                            etcValues[d?.BU_ID] = {
                                [d?.Cost_Type]: pNum(d?.Value_Amount)
                            }
                        }
                    }


                    if (d?.Forecast_Tab === 'Summary' && d?.Forecast_Field_Name === 'highlighted') {
                        highlightedJob[d?.BU_ID] = d?.Forecast_Value
                    }
                })
                setEquipmentUserData(phasedEquipment)
                setHighlightedJob(highlightedJob)

                let etcLabor = {}
                let etcLaborTwo = {}
                let etcIncentive = {}
                let etcEquipment = {}
                let etcMaterials = {}
                let etcRentals = {}
                let etcSubcontractors = {}
                let etcOther = {}
                let etcContingency = {}
                let totalContingency = 0
                let etcTotal = {}
                let hours = {}


                let equipmentCostTypePieces = {}
                let laborCostTypePieces = {}
                let regularTimePieces = {}

                const contingencyPieces = {}
                jobIds.forEach((job) => {
                    let regularTimeCostType = 0
                    let equipmentCostType = 0
                    let regularTime = 0
                    let regularHours = 0
                    let etc = 0
                    const pC = completionDates[job]


                    equipmentValues[job] && Object.keys(equipmentValues[job]).forEach((key) => {
                        if (job == '54024093') console.log('093', key, equipmentValues[job][key])
                        if (key.length == 10 && moment(key).isAfter(moment(versionInfo?.Version_Start_DateTime).startOf('week')) && moment(pC).endOf('week').isAfter(key)) {
                            const row = equipmentValues[job]?.[key]
                            const costCode = row.Cost_Code && row.Cost_Code != 'undefined' ? row.Cost_Code : '100105'
                            if (!equipmentCostTypePieces[job]) {
                                equipmentCostTypePieces[job] = {}
                            }
                            if (!equipmentCostTypePieces[job][row.Cost_Type]) {
                                equipmentCostTypePieces[job][row.Cost_Type] = {}
                            }
                            if (!equipmentCostTypePieces[job][row.Cost_Type][costCode]) {
                                equipmentCostTypePieces[job][row.Cost_Type][costCode] = 0
                            }
                            equipmentCostTypePieces[job][row.Cost_Type][costCode] = equipmentCostTypePieces[job][row.Cost_Type][costCode] + (isNaN(pNum(row.Rate)) ? 0 : pNum(row.Rate)) * (isNaN(pNum(row.Number_Units)) ? 0 : pNum(row.Number_Units)) * (isNaN(pNum(row.Number_Hours)) ? 0 : pNum(row.Number_Hours))
                            equipmentCostType = equipmentCostType + ((isNaN(pNum(row.Rate)) ? 0 : pNum(row.Rate)) * (isNaN(pNum(row.Number_Units)) ? 0 : pNum(row.Number_Units)) * (isNaN(pNum(row.Number_Hours)) ? 0 : pNum(row.Number_Hours)))
                        }
                    })


                    laborValues[job] && Object.values(laborValues[job]).forEach((row) => {
                        if (row) {
                            const costCode = row.Cost_Code && row.Cost_Code != 'undefined' ? row.Cost_Code : '100105'
                            const week = row?.Forecast_Row_ID ? row.Forecast_Row_ID.split('*')[0] : ''
                            const pC = completionDates[job]
                            //if(job == '54024082')console.log('a', week, moment(week).isAfter(moment(versionInfo?.Version_Start_DateTime).startOf('week')), moment(pC).isAfter(week))
                            if (week && moment(week).isAfter(moment(versionInfo?.Version_Start_DateTime).startOf('week')) && moment(pC).isAfter(week)) {
                                if (!laborCostTypePieces[job]) {
                                    laborCostTypePieces[job] = {
                                        '51100': {
                                            [costCode]: 0
                                        }
                                    }
                                }
                                if (!laborCostTypePieces[job]['51100'][costCode]) {
                                    laborCostTypePieces[job]['51100'][costCode] = 0
                                }
                                laborCostTypePieces[job]['51100'][costCode] = laborCostTypePieces[job]['51100'][costCode] + (!isNaN(pNum(row.Rate)) && !isNaN(pNum(row.Number_Units)) && !isNaN(pNum(row.Number_Hours)) ? pNum(row.Rate) * pNum(row.Number_Units) * pNum(row.Number_Hours) : 0)
                                regularTimeCostType = regularTimeCostType + (!isNaN(pNum(row.Rate)) && !isNaN(pNum(row.Number_Units)) && !isNaN(pNum(row.Number_Hours)) ? pNum(row.Rate) * pNum(row.Number_Units) * pNum(row.Number_Hours) : 0)
                                regularHours = regularHours + (!isNaN(pNum(row.Number_Hours)) && !isNaN(pNum(row.Number_Units)) ? pNum(row.Number_Hours) * pNum(row.Number_Units) : 0)
                            }
                        }
                    })


                    phasedLabor[job] && Object.keys(phasedLabor[job]).forEach((row) => {
                        const weekRow = row.includes('=')
                        const week = row.split('=')[1]
                        const phase = row.split('=')[0]
                        const pC = completionDates[job]
                        const phaseDetails = phase ? phasedLabor[job][phase] : {}
                        const withinProject = moment(week).isAfter(moment(versionInfo.Version_Start_DateTime).startOf('week')) && moment(week).isBefore(moment(pC).endOf('week'))
                        const withinStartStop = true//moment(week).isAfter(moment(phaseDetails?.startDate).startOf('week')) && moment(week).isBefore(moment(phaseDetails?.endDate).endOf('week'))
                        const h = phasedLabor[job][row]?.Number_Hours ? phasedLabor[job][row].Number_Hours : 0
                        const bR = phasedLabor[job][row]?.Rate ? phasedLabor[job][row].Rate : 0
                        const cS = phasedLabor[job][row]?.Number_Units ? phasedLabor[job][row].Number_Units : 0
                        if (weekRow && phasedLabor[job][row] && h && bR && cS && withinProject && withinStartStop) {
                            if (!regularTimePieces[job]) {
                                regularTimePieces[job] = {
                                    ['51100']: {
                                        [phase]: 0
                                    }
                                }
                            }
                            if (!regularTimePieces[job]['51100'][phase]) {
                                regularTimePieces[job]['51100'][phase] = 0
                            }

                            regularTimePieces[job]['51100'][phase] = regularTimePieces[job]['51100'][phase] + (!isNaN(pNum(bR)) && !isNaN(pNum(h)) && !isNaN(pNum(cS)) ? pNum(bR) * pNum(h) * pNum(cS) : 0)
                            regularHours = regularHours + (!isNaN(pNum(h)) && !isNaN(pNum(cS)) ? pNum(h) * pNum(cS) : 0)
                            regularTime = regularTime + (!isNaN(pNum(h)) && !isNaN(pNum(bR)) && !isNaN(pNum(cS)) ? pNum(h) * pNum(bR) * pNum(cS) : 0)
                        }
                    })

                    let labor = 0
                    let materials = 0
                    let equipment = 0
                    let rentals = 0
                    let subcontractors = 0
                    let other = 0
                    let contingency = 0
                    let total = 0

                    etcValues[job] && Object.keys(etcValues[job]).forEach((row) => {
                        etc = etc + (isNaN(pNum(etcValues[job][row])) ? 0 : pNum(etcValues[job][row]))
                        //if(job == '54024086') //console.log(etcValues[job][row][0], job, row, labor, rentals, materials, subcontractors, other);
                        if (row[0] == '5' && row[1] == '1' && (row[2] == '6' || row[2] == '7' || row[2] == '8')) {
                            labor = labor + (isNaN(pNum(etcValues[job][row])) ? 0 : pNum(etcValues[job][row]))
                        } else if (row[0] == '5' && row[1] == '2') {
                            rentals = rentals + (isNaN(pNum(etcValues[job][row])) ? 0 : pNum(etcValues[job][row]))
                        } else if (row[0] == '5' && row[1] == '3') {
                            materials = materials + (isNaN(pNum(etcValues[job][row])) ? 0 : pNum(etcValues[job][row]))
                        } else if (row[0] == '5' && row[1] == '4') {
                            subcontractors = subcontractors + (isNaN(pNum(etcValues[job][row])) ? 0 : pNum(etcValues[job][row]))
                        } else if (row[0] == '5' && (row[1] == '5' || row[1] == '6' || row[1] == '7')) {
                            other = other + (isNaN(pNum(etcValues[job][row])) ? 0 : pNum(etcValues[job][row]))
                        }
                    })

                    let totalcLabor = 0
                    let totalcEquipment = 0
                    let totalcMaterials = 0
                    let totalcSubcontractors = 0
                    let totalcOtherExpenses = 0
                    let totalcTotal = 0

                    contingencyPieces[job] = {
                        '51100': {
                            '101101': 0
                        },
                        '52100': {
                            '101101': 0
                        },
                        '53100': {
                            '101101': 0
                        },
                        '54200': {
                            '101101': 0
                        },
                        '57900': {
                            '101101': 0
                        }
                    }

                    contingData[job] && Object.values(contingData[job]).forEach((row) => {
                        totalcLabor = totalcLabor + (isNaN(pNum(row.CurrentLabor)) ? 0 : pNum(row.CurrentLabor))
                        contingencyPieces[job]['51100']['101101'] = contingencyPieces[job]['51100']['101101'] + (isNaN(pNum(row.CurrentLabor)) ? 0 : pNum(row.CurrentLabor))
                        totalcEquipment = totalcEquipment + (isNaN(pNum(row.CurrentEquipment)) ? 0 : pNum(row.CurrentEquipment))
                        contingencyPieces[job]['52100']['101101'] = contingencyPieces[job]['52100']['101101'] + (isNaN(pNum(row.CurrentEquipment)) ? 0 : pNum(row.CurrentEquipment))
                        totalcMaterials = totalcMaterials + (isNaN(pNum(row.CurrentMaterials)) ? 0 : pNum(row.CurrentMaterials))
                        contingencyPieces[job]['53100']['101101'] = contingencyPieces[job]['53100']['101101'] + (isNaN(pNum(row.CurrentMaterials)) ? 0 : pNum(row.CurrentMaterials))
                        totalcSubcontractors = totalcSubcontractors + (isNaN(pNum(row.CurrentSubs)) ? 0 : pNum(row.CurrentSubs))
                        contingencyPieces[job]['54200']['101101'] = contingencyPieces[job]['54200']['101101'] + (isNaN(pNum(row.CurrentSubs)) ? 0 : pNum(row.CurrentSubs))
                        totalcOtherExpenses = totalcOtherExpenses + (isNaN(pNum(row.CurrentOther)) ? 0 : pNum(row.CurrentOther))
                        contingencyPieces[job]['57900']['101101'] = contingencyPieces[job]['57900']['101101'] + (isNaN(pNum(row.CurrentOther)) ? 0 : pNum(row.CurrentOther))
                    })
                    totalcTotal = totalcLabor + totalcEquipment + totalcMaterials + totalcSubcontractors + totalcOtherExpenses

                    //totalCost[job] = equipmentETC + regularTime + etc + totalcTotal
                    hours[job] = regularHours
                    if (job == '54024093') console.log('labor and equipment', equipmentValues);
                    etcLabor[job] = labor + regularTimeCostType + regularTime
                    etcLaborTwo[job] = regularTimeCostType
                    etcIncentive[job] = labor
                    etcEquipment[job] = equipmentCostType
                    etcMaterials[job] = materials
                    etcRentals[job] = rentals
                    etcSubcontractors[job] = subcontractors
                    etcOther[job] = other
                    etcContingency[job] = totalcTotal
                    totalContingency = totalContingency + totalcTotal
                    etcTotal[job] = labor + regularTimeCostType + equipmentCostType + materials + rentals + subcontractors + other + totalcTotal
                })

                setContingencyPieces(contingencyPieces)
                setHoursETC(hours)
                setLabor(etcLabor)
                setLaborCostType(etcLaborTwo)
                setEquipmentCostType(etcEquipment)
                setMaterials(etcMaterials)
                setRentals(etcRentals)
                setSubcontractors(etcSubcontractors)
                setOther(etcOther)
                setContingency(etcContingency)
                setTotalContingency(fNum(totalContingency, 1))
                setIncentive(etcIncentive)
                setTotal(etcTotal)
                setETC(etcTotal)

                //parts for projections
                setEtcPieces(etcValuesPieces)
                setLaborPieces(laborCostTypePieces)
                setLaborPhasedPieces(regularTimePieces)
                setEquipmentPieces(equipmentCostTypePieces)


                let curBudget = {}
                let totalBudget = 0
                filteredJobs.forEach((job) => {
                    let jobCurBudget = 0
                    dayZeroValues[job.BU_ID] && Object.values(dayZeroValues[job.BU_ID]).forEach((row) => {
                        if (row['Cost_Type'] && row['Cost_Type'].length) {
                            if (row['Cost_Type'][0] == '4') {
                                jobCurBudget = jobCurBudget + pNum(row['Value_Amount'])
                            }
                        }
                    })
                    //if(job.BU_ID == '50224025') //console.log('25 row f', jobCurBudget);


                    chOrValues[job.BU_ID] && Object.values(chOrValues[job.BU_ID]).forEach((row) => {
                        if (row.Status === 'Approved') {
                            jobCurBudget = jobCurBudget + (isNaN(pNum(row['41000'])) ? 0 : pNum(row['41000']))
                            // jobCurBudget = jobCurBudget + (isNaN(pNum(row.tAndM)) ? 0 : pNum(row.tAndM))
                            // jobCurBudget = jobCurBudget + (isNaN(pNum(row.changeOrders)) ? 0 : pNum(row.changeOrders))
                            // jobCurBudget = jobCurBudget + (isNaN(pNum(row.reductionOfScope)) ? 0 : pNum(row.reductionOfScope))
                        }
                    })
                    curBudget[job.BU_ID] = jobCurBudget > 0 ? fNum(jobCurBudget, 1) : ''
                    totalBudget = totalBudget + (jobCurBudget > 0 ? jobCurBudget : 0)
                })
                setCurBudget(curBudget)
                setTotalBudget(fNum(totalBudget, 1))
                setStartDates(startDates)
                setCompletionDates(completionDates)
                setMechCompleteDates(mechanicallyCompleteDates)
                setPhysicalComplete(physicalComplete)
            })

            loadTeamUserData({ ids: jobIds, forecastGuid: selectedWIP?.Version_GUID }).then((data) => {
                let contData = {}
                let totalPrevContingency = 0
                ////console.log('wip data', data);
                data?.data?.forEach((d) => {
                    if (d?.Forecast_Tab === 'Contingency') {
                        if (contData[d?.BU_ID]?.[d?.Forecast_Row_ID]) {
                            contData[d?.BU_ID][d?.Forecast_Row_ID][d.Forecast_Field_Name] = d.Forecast_Value
                        } else if (contData[d?.BU_ID]) {
                            contData[d?.BU_ID][d?.Forecast_Row_ID] = {
                                id: d?.Forecast_Row_ID,
                                [d.Forecast_Field_Name]: d.Forecast_Value
                            }
                        } else {
                            contData[d?.BU_ID] = {
                                [d?.Forecast_Row_ID]: {
                                    id: d?.Forecast_Row_ID,
                                    [d.Forecast_Field_Name]: d.Forecast_Value
                                }
                            }
                        }
                    }
                })
                jobIds.forEach((job) => {
                    let totalLabor = 0
                    let totalEquipment = 0
                    let totalMaterials = 0
                    let totalSubcontractors = 0
                    let totalOtherExpenses = 0
                    contData[job] && Object.values(contData[job]).forEach((row) => {
                        totalLabor = totalLabor + (isNaN(pNum(row.CurrentLabor)) ? 0 : pNum(row.CurrentLabor))
                        totalEquipment = totalEquipment + (isNaN(pNum(row.CurrentEquipment)) ? 0 : pNum(row.CurrentEquipment))
                        totalMaterials = totalMaterials + (isNaN(pNum(row.CurrentMaterials)) ? 0 : pNum(row.CurrentMaterials))
                        totalSubcontractors = totalSubcontractors + (isNaN(pNum(row.CurrentSubs)) ? 0 : pNum(row.CurrentSubs))
                        totalOtherExpenses = totalOtherExpenses + (isNaN(pNum(row.CurrentOther)) ? 0 : pNum(row.CurrentOther))
                    })
                    const totalcTotal = totalLabor + totalEquipment + totalMaterials + totalSubcontractors + totalOtherExpenses
                    contData[job] = totalcTotal
                    totalPrevContingency = totalPrevContingency + totalcTotal
                })
                setPrevContingency(contData)
                setTotalPrevContingency(fNum(totalPrevContingency, 1))
            })

            const jobIds1 = jobIds//.slice(0, 40)
            const wipDate = selectedWIP?.Version_Start_DateTime ? moment(selectedWIP?.Version_Start_DateTime).endOf('month').format('YYYY-MM-DD') : ''
            loadTeamCostDetailProjections({ ids: jobIds1, forecastGuid: selectedVersion, wip: wipDate }).then((data) => {
                setProjectionCost(data?.data)
            })

            //const jobIds2 = jobIds.slice(40, jobIds.length)
            let actualCost = {}
            let actualCostPieces = {}
            let actualOverhead = {}
            let hours = {}
            let revenue = {}
            let revenuePrevPeriod = {}
            loadTeamCostDetail({ ids: jobIds1, forecastGuid: selectedVersion, wip: moment().add(1, 'month').format('YYYY-MM-DD') }).then((data) => {
                ////console.log('cost detail', data);
                data?.data?.forEach((d) => {
                    if ((d?.Cost_Category == 'Job Cost - All Others' || d?.Cost_Category == 'Job Cost - Labor') && actualCost[d?.Job_Number]) {
                        actualCost[d?.Job_Number] = actualCost[d?.Job_Number] + (isNaN(pNum(d?.Total_Job_Cost)) ? 0 : pNum(d?.Total_Job_Cost))
                    } else if (d?.Cost_Category == 'Job Cost - All Others' || d?.Cost_Category == 'Job Cost - Labor') {
                        actualCost[d?.Job_Number] = (isNaN(pNum(d?.Total_Job_Cost)) ? 0 : pNum(d?.Total_Job_Cost))
                    }

                    if (d?.Cost_Category == 'OH' && actualOverhead[d?.Job_Number]) {
                        actualOverhead[d?.Job_Number] = actualOverhead[d?.Job_Number] + (isNaN(pNum(d?.Total_Job_Cost)) ? 0 : pNum(d?.Total_Job_Cost))
                    } else if (d?.Cost_Category == 'OH') {
                        actualOverhead[d?.Job_Number] = (isNaN(pNum(d?.Total_Job_Cost)) ? 0 : pNum(d?.Total_Job_Cost))
                    }

                    if (d?.Cost_Category == 'Job Cost - Labor' && hours[d?.Job_Number]) {
                        hours[d?.Job_Number] = hours[d?.Job_Number] + (isNaN(pNum(d?.Total_Hours)) ? 0 : pNum(d?.Total_Hours))
                    } else if (d?.Cost_Category == 'Job Cost - Labor') {
                        hours[d?.Job_Number] = (isNaN(pNum(d?.Total_Hours)) ? 0 : pNum(d?.Total_Hours))
                    }

                    if (d?.Cost_Category == 'Revenue' && revenue[d?.Job_Number]) {
                        revenue[d?.Job_Number] = revenue[d?.Job_Number] + (isNaN(pNum(d?.Total_Job_Cost)) ? 0 : pNum(d?.Total_Job_Cost))
                    } else if (d?.Cost_Category == 'Revenue') {
                        revenue[d?.Job_Number] = (isNaN(pNum(d?.Total_Job_Cost)) ? 0 : pNum(d?.Total_Job_Cost))
                    }

                })
                //setEarnedRevenue(revenue)
                ////console.log( 'actualCost', actualCost);
                setActualHours(hours)
                setActualCost(actualCost)
                //console.log('setting actual overhead', actualOverhead);
                setActualOverhead(actualOverhead)
            })

            //const wipDate = selectedWIP?.Version_Start_DateTime ? moment(selectedWIP?.Version_Start_DateTime).endOf('month').format('YYYY-MM-DD') : ''
            loadTeamCostDetail({ ids: jobIds1, forecastGuid: selectedVersion, wip: wipDate }).then((data) => {
                data?.data?.forEach((d) => {
                    if (d?.Cost_Category == 'Revenue') {
                        revenuePrevPeriod[d?.Job_Number] = (isNaN(pNum(d?.Total_Job_Cost)) ? 0 : pNum(d?.Total_Job_Cost))
                    }
                })
                ////console.log('earned rev rows', revenuePrevPeriod, wipDate, data?.data);
                setEarnedRevenueRows(revenuePrevPeriod)
            })

            let openCommitments = {}
            let openCommitmentsPieces = {}
            let openCommitmentsBreakout = {}
            loadTeamOpemCommitments({ ids: jobIds, forecastGuid: selectedVersion }).then((data) => {
                //console.log('open commitments data', data?.data.length, data?.data[0])
                data?.data?.forEach((d) => {
                    if (d?.Cost_Type_Code?.[0] == '5' && openCommitments[d?.Job_Number]) {
                        openCommitments[d?.Job_Number] = openCommitments[d?.Job_Number] + (isNaN(pNum(d?.PO_True_Open_Amount)) ? 0 : pNum(d?.PO_True_Open_Amount))
                    } else if (d?.Cost_Type_Code?.[0] == '5') {
                        openCommitments[d?.Job_Number] = (isNaN(pNum(d?.PO_True_Open_Amount)) ? 0 : pNum(d?.PO_True_Open_Amount))
                    }

                    const costCode = d.Cost_Code ? d.Cost_Code : '100105'
                    if (!openCommitmentsPieces[d?.Job_Number]) {
                        openCommitmentsPieces[d?.Job_Number] = {}
                    }
                    if (!openCommitmentsPieces[d?.Job_Number][d?.Cost_Type_Code]) {
                        openCommitmentsPieces[d?.Job_Number][d?.Cost_Type_Code] = {}
                    }
                    if (!openCommitmentsPieces[d?.Job_Number][d?.Cost_Type_Code][costCode]) {
                        openCommitmentsPieces[d?.Job_Number][d?.Cost_Type_Code][costCode] = 0
                    }
                    openCommitmentsPieces[d?.Job_Number][d?.Cost_Type_Code][costCode] = openCommitmentsPieces[d?.Job_Number][d?.Cost_Type_Code][costCode] + (isNaN(pNum(d?.PO_True_Open_Amount)) ? 0 : pNum(d?.PO_True_Open_Amount))
                })
                ////console.log( 'openCommitments', openCommitments, data?.data);
                setOpenCommitments(openCommitments)
                setOpenCommitmentsPieces(openCommitmentsPieces)
            })

            loadTeamBillings({ ids: jobIds, forecastGuid: selectedVersion }).then((data) => {
                let mostRecent = {}
                const billingData = {}
                const billings = {}
                data?.data?.forEach((d) => {
                    if (billingData[d?.Job_Number]) {
                        billingData[d?.Job_Number].push(d)
                    } else {
                        billingData[d?.Job_Number] = [d]
                    }
                })


                Object.values(billingData).forEach((bills) => {
                    let mostRecentCostDate = '2021-01-01'
                    let invoices = 0
                    bills.forEach((d) => {
                        if (d?.GL_Date && moment(d?.GL_Date).isAfter(moment(mostRecentCostDate))) {
                            mostRecentCostDate = moment(d?.GL_Date).format('M/D/YYYY')
                        }
                        invoices = invoices + pNum(d?.Invoice_Amount)
                    })
                    mostRecent[bills[0]?.Job_Number] = mostRecentCostDate
                    billings[bills[0]?.Job_Number] = invoices
                })
                setMostRecentBill(mostRecent)
                setBillings(billings)
            })

            //jobIds && jobIds.forEach((job, index) => {
            loadSummaryWIPArray({ ids: jobIds, wip: wipDate }).then((data) => {
                //if (index == 10) //console.log('prevWIP', data);
                ////console.log('prevWIP', data);
                let rev = {}
                let cost = {}
                let oh = {}
                let w = {}
                data?.data.forEach((d) => {
                    if (d?.Account_Category === 'Revenue' && rev[d?.BU_ID]) {
                        rev[d.BU_ID] = rev[d.BU_ID] + (isNaN(pNum(d?.Total_Amount)) ? 0 : pNum(d?.Total_Amount))
                    } else if (d?.Account_Category === 'Revenue') {
                        rev[d.BU_ID] = (isNaN(pNum(d?.Total_Amount)) ? 0 : pNum(d?.Total_Amount))
                    } else if (d?.Account_Category === 'Job Cost' && cost[d?.BU_ID]) {
                        cost[d.BU_ID] = cost[d.BU_ID] + (isNaN(pNum(d?.Total_Amount)) ? 0 : pNum(d?.Total_Amount))
                    } else if (d?.Account_Category === 'Job Cost') {
                        cost[d.BU_ID] = (isNaN(pNum(d?.Total_Amount)) ? 0 : pNum(d?.Total_Amount))
                    } else if (d?.Account_Category === 'OH' && oh[d?.BU_ID]) {
                        oh[d.BU_ID] = oh[d.BU_ID] + (isNaN(pNum(d?.Total_Amount)) ? 0 : pNum(d?.Total_Amount))
                    } else if (d?.Account_Category === 'OH') {
                        oh[d.BU_ID] = (isNaN(pNum(d?.Total_Amount)) ? 0 : pNum(d?.Total_Amount))
                    }
                })
                ////console.log('prevWIP', wipDate, rev, cost, oh);
                //if (job == '50223020') //console.log('prevWIP', wipDate, job, rev, cost, oh);
                jobIds.forEach((job) => {
                    w[job] = {
                        revenue: rev[job],
                        cost: cost[job],
                        overhead: oh[job],
                        total: -rev[job] - cost[job],
                        percent: rev[job] ? fNum((-rev[job] - cost[job]) / -rev[job] * 100) : ''
                    }
                })
                setJobPrevWIP(w)
            })
        }

    }, [filteredJobs])

    useEffect(() => {
        const phasedEquipmentCost = {}
        const equipmentRates = {}
        const equipmentPieces = {}
        const jobIds = filteredJobs.map(j => j.BU_ID)
        jobIds.forEach((job) => {
            equipmentUserData[job] && Object.keys(equipmentUserData[job]).forEach((row) => {
                if (equipmentUserData[job]?.[row]?.weekPerUnit) {
                    equipmentRates[equipmentUserData[job][row].equipment] = equipmentUserData[job][row].weekPerUnit
                }
            })
        })

        ////console.log('equipRates', equipmentUserData, equipmentRates);

        jobIds.forEach((job) => {
            let equipmentETC = 0
            equipmentUserData[job] && Object.keys(equipmentUserData[job]).forEach((t) => {
                const r = equipmentUserData[job][t]
                const pC = completionDates[job]
                const v = versionInfo?.Version_Start_DateTime

                // Row IDs use '=' (new) or '*' (legacy) between name and week
                const _sep = t.includes('=') ? '=' : '*'
                const _idx = t.lastIndexOf(_sep)
                const w = _idx >= 0 ? t.substring(_idx + 1) : undefined
                const e = _idx >= 0 ? t.substring(0, _idx) : t
                const rate = r?.Rate
                const h = r?.Number_Hours
                const n = r?.Number_Units
                ////console.log('e0', e, w, '-', h, '---', n, rate, moment(w).isAfter(moment(v).startOf('week')), moment(w).isBefore(pC))
                if (w && h && n && rate && moment(w).isAfter(moment(v).startOf('week')) && moment(w).isBefore(pC)) {
                    ////console.log('e1', job, r, (!isNaN(pNum(rate)) && !isNaN(pNum(h)) && !isNaN(pNum(n)) ? pNum(rate) * pNum(h) * pNum(n) : 0))
                    if (!equipmentPieces[job]) {
                        equipmentPieces[job] = {
                            '52100': {
                                [r.phaseCode]: 0
                            }
                        }
                    }
                    if (!equipmentPieces[job]['52100'][r.phaseCode]) {
                        equipmentPieces[job]['52100'][r.phaseCode] = 0
                    }
                    equipmentPieces[job]['52100'][r.phaseCode] = equipmentPieces[job]['52100'][r.phaseCode] + (!isNaN(pNum(rate)) && !isNaN(pNum(h)) && !isNaN(pNum(n)) ? pNum(rate) * pNum(h) * pNum(n) : 0)
                    ////console.log('e2', e, job, w, rate, equipRates[e], equipmentRates[e], equipmentETC, (!isNaN(pNum(rate)) && !isNaN(pNum(h)) && !isNaN(pNum(n)) ? pNum(rate) * pNum(h) * pNum(n) : 0))
                    equipmentETC = equipmentETC + (!isNaN(pNum(rate)) && !isNaN(pNum(h)) && !isNaN(pNum(n)) ? pNum(rate) * pNum(h) * pNum(n) : 0)

                }
            })
            //if (equipmentETC) //console.log( 'e3', job, equipmentETC)
            phasedEquipmentCost[job] = equipmentETC

        })
        ////console.log('equipmentPhasedPieces--', equipmentPieces);
        ////console.log( 'phasedEquipmentCost', phasedEquipmentCost);
        setEquipmentPhased(phasedEquipmentCost)
        setEquipmentPhasedPieces(equipmentPieces)
    }, [equipmentUserData, equipRates, completionDates, filteredJobs])

    useEffect(() => {
        const jobIds = filteredJobs.map(j => j.BU_ID)
        const etc = {}
        jobIds.forEach((job) => {
            let etcTotal = labor[job] + materials[job] + rentals[job] + subcontractors[job] + other[job] + equipmentPhased[job] + equipmentCostType[job] + contingency[job]
            if (job == '54024082') console.log('etcTotal', job, labor[job], materials[job], rentals[job], subcontractors[job], other[job], equipmentPhased[job], equipmentCostType[job], contingency[job], etcTotal)
            etc[job] = etcTotal
        })
        setETC(etc)
        setTotal(etc)
    }, [equipmentPhased, equipmentCostType, contingency])

    useEffect(() => {
        let EAC = {}
        let tCost = {}
        let totalEAC = 0
        let jobProfit = {}
        let totalProfit = 0
        let jobProfitPerc = {}
        let jobGrossMargin = {}
        let totalGrossMargin = 0
        let jobGrossMarginPerc = {}
        let backlog = {}
        let totalBacklog = 0
        let costPercent = {}
        let earnedRevenue = {}
        console.log('first 54024064', openCommitments['54024064'], ETC['54024064'], actualCost['54024064'])
        filteredJobs.forEach((job, index) => {
            const total = (pNum(actualCost[job.BU_ID]) + pNum(openCommitments[job.BU_ID]) + pNum(ETC[job.BU_ID]))
            EAC[job.BU_ID] = total > 0 ? fNum(total, 1) : ''
            const cost = (pNum(actualCost[job.BU_ID]) + pNum(openCommitments[job.BU_ID]))
            tCost[job.BU_ID] = cost > 0 ? fNum(cost, 1) : ''
            totalEAC = totalEAC + (total > 0 ? total : 0)
            //if(index == 7) //console.log('second', total, 'b', curBudget[job.BU_ID])
            jobProfit[job.BU_ID] = total > 0 && curBudget[job.BU_ID] ? fNum(pNum(curBudget[job.BU_ID]) - total, 1) : ''
            totalProfit = totalProfit + (jobProfit[job.BU_ID] ? pNum(jobProfit[job.BU_ID]) : 0)
            jobProfitPerc[job.BU_ID] = jobProfit[job.BU_ID] ? fNum(pNum(jobProfit[job.BU_ID]) / pNum(curBudget[job.BU_ID]) * 100) : ''

            //if (job.BU_ID == '50224024')//console.log('job profit', curBudget[job.BU_ID], total, actualOverhead, actualOverhead[job.BU_ID], etcOverhead[job.BU_ID])
            const grossMargin = (pNum(curBudget[job.BU_ID]) - total - (isNaN(pNum(actualOverhead[job.BU_ID])) ? 0 : pNum(actualOverhead[job.BU_ID]))) - (isNaN(pNum(etcOverhead[job.BU_ID])) ? 0 : pNum(etcOverhead[job.BU_ID]))
            totalGrossMargin = totalGrossMargin + grossMargin
            const grossMarginPerc = grossMargin && curBudget[job.BU_ID] ? fNum(grossMargin / pNum(curBudget[job.BU_ID]) * 100) : ''
            jobGrossMargin[job.BU_ID] = grossMargin
            jobGrossMarginPerc[job.BU_ID] = grossMarginPerc

            backlog[job.BU_ID] = (1 - (pNum(actualCost[job.BU_ID]) / total)) * pNum(curBudget[job.BU_ID])
            totalBacklog = totalBacklog + (backlog[job.BU_ID] ? pNum(backlog[job.BU_ID]) : 0)
            costPercent[job.BU_ID] = total ? (pNum(actualCost[job.BU_ID]) / total) * 100 : ''
            earnedRevenue[job.BU_ID] = (costPercent[job.BU_ID] / 100) * pNum(curBudget[job.BU_ID])
        })
        // //console.log('job profit', jobProfit)
        setEAC(EAC)
        setTotalCost(tCost)
        setTotalEAC(fNum(totalEAC, 1))
        setJobProfit(jobProfit)
        setTotalJobProfit(fNum(totalProfit, 1))
        setJobProfitPerc(jobProfitPerc)
        setTotalJobProfitPercent(fNum(totalProfit / pNum(totalBudget) * 100, 2) + '%')
        setGrossMargin(jobGrossMargin)
        setTotalGrossMargin(fNum(totalGrossMargin, 1))
        setGrossMarginPerc(jobGrossMarginPerc)
        setTotalGrossMarginPercent(fNum(totalGrossMargin / pNum(totalBudget) * 100, 2) + '%')
        setBacklog(backlog)
        setTotalBacklog(fNum(totalBacklog, 1))
        setCostPercent(costPercent)
        setEarnedRevenue(earnedRevenue)

    }, [openCommitments, actualCost, ETC, curBudget, totalBudget])


    useEffect(() => {
        let jobs = [];
        let uniqueCombinations = new Map();

        const addToTotals = (jobId, costType, phaseCode, value, source) => {
            if (costType?.startsWith("51800") && source !== "actuals" && source !== "openCommitments") {
                phaseCode = "100105";
            }

            if (costType === "52400" && phaseCode === "100105") {
                phaseCode = "100102";
            }

            if (costType === "54200" && phaseCode === "100105") {
                phaseCode = "100101";
            }

            // If costType is 51100 or 52100 and phaseCode is undefined, set to 100105
            if ((costType === "51100" || costType === "52100") && (!phaseCode || phaseCode == 'undefined') && source !== "actuals" && source !== "openCommitments") {
                phaseCode = "100105";
            }

            if (phaseCode && phaseCode.includes('^')) {
                phaseCode = '100105'
            }

            const key = `${jobId}-${costType}-${phaseCode}`;

            if (uniqueCombinations.has(key)) {
                // If already exists, sum the value
                uniqueCombinations.set(key, value ? uniqueCombinations.get(key) + value : uniqueCombinations.get(key));
            } else {
                // Otherwise, store the new value
                uniqueCombinations.set(key, value);
            }
        };

        const processDataset = (dataset, source) => {
            Object.keys(dataset).forEach((jobId) => {
                const job = dataset[jobId];
                Object.keys(job).forEach((costType) => {
                    Object.keys(job[costType]).forEach((phaseCode) => {
                        // if (costType == '51100' && source == 'etc') {

                        // } else {
                        addToTotals(jobId, costType, phaseCode, pNum(job[costType][phaseCode]), source);
                        //}
                    });
                });
            });
        };


        console.log('opencommitmentsPieces', openCommitmentsPieces);
        console.log('laborPieces', laborPieces);
        console.log('laborPhasedPieces', laborPhasedPieces);
        console.log('equipmentCostTypePieces', equipmentPieces);
        console.log('equipmentPhasedPieces', equipmentPhasedPieces);
        console.log('contingencyPieces', contingencyPieces);
        console.log('etcPieces', etcPieces);
        console.log('projectionCost', projectionCost);
        // Process all datasets
        processDataset(openCommitmentsPieces, "openCommitments");
        processDataset(laborPieces, "labor");
        processDataset(laborPhasedPieces, "laborPhased");
        processDataset(equipmentPieces, "equipment");
        processDataset(equipmentPhasedPieces, "equipmentPhased");
        processDataset(contingencyPieces, "contingency");
        processDataset(etcPieces, "etc");

        // Process projection costs separately
        projectionCost && projectionCost.forEach((job, index) => {
            //if (index == 0) console.log('projectionCost', job);
            addToTotals(job.Job_Number, job.Cost_Type_Code, job.Phase_Code, pNum(job.Total_Job_Cost), "actuals");
        });
        //console.log('unique combinations', uniqueCombinations);

        const tierSize = {};
        filteredJobs.forEach((job) => {
            if (job?.BU_ID) {
                tierSize[job.BU_ID] = job?.Cat_Code_BU_16;
            }
        });

        // // Log all unique combinations that have 16125002 and 51*
        // let sum = 0
        // uniqueCombinations.forEach((value, key) => {
        //     const [jobId, costType] = key.split("-");
        //     if (jobId === "16125002" && costType.startsWith("51")) {
        //     sum += value
        //     console.log(`Key: ${key}, Value: ${value}, Sum: ${sum}`);

        //     }
        // });
        const finalData = Array.from(uniqueCombinations, ([key, value]) => {
            const [jobId, costType, phaseCode] = key.split("-");
            return { jobId, costType, phaseCode, value: fNum(value), tier: tierSize[jobId] };
        });

        filteredJobs.forEach((job) => {
            finalData.push({
                jobId: job.BU_ID,
                costType: '41000',
                phaseCode: '990000',
                value: curBudget[job.BU_ID] ? '-' + curBudget[job.BU_ID] : 0
            })

            finalData.push({
                jobId: job.BU_ID,
                costType: '60900',
                phaseCode: '1000',
                value: actualOverhead[job.BU_ID] && etcOverhead[job.BU_ID] ? fNum(pNum(actualOverhead[job.BU_ID]) + pNum(etcOverhead[job.BU_ID])) : actualOverhead[job.BU_ID] ? fNum(actualOverhead[job.BU_ID]) : etcOverhead[job.BU_ID] ? fNum(etcOverhead[job.BU_ID]) : 0
            })
        })

        //console.log("Summed Job-CostType-PhaseCode Combinations:", finalData, actualOverhead, etcOverhead);

        setProjectionRows(finalData);
    }, [filteredJobs, openCommitmentsPieces, projectionCost, equipmentPieces, equipmentPhasedPieces, actualOverhead]);

    useEffect(() => {
        let jobs = []
        let details = {}
        let totals = { open: {}, actual: {}, etc: {}, fieldBonus: {}, rentals: {}, materials: {}, subcontractors: {}, other: {}, contingency: {}, laborCostType: {}, laborPhased: {}, equipmentCostType: {}, equipmentPhased: {}, etc: {} }

        Object.keys(openCommitmentsPieces).forEach((id) => {
            const job = openCommitmentsPieces[id]
            let jobTotal = 0
            Object.values(job).forEach((costType) => {
                Object.values(costType).forEach((code) => {
                    jobTotal = jobTotal + pNum(code)
                })
            })
            totals.open[id] = jobTotal
        })

        Object.keys(laborPieces).forEach((id) => {
            const job = laborPieces[id]
            let jobTotal = 0
            Object.values(job).forEach((costType) => {
                Object.values(costType).forEach((code) => {
                    jobTotal = jobTotal + pNum(code)
                })
            })
            totals.laborCostType[id] = jobTotal
        })

        Object.keys(laborPhasedPieces).forEach((id) => {
            const job = laborPhasedPieces[id]
            let jobTotal = 0
            Object.values(job).forEach((costType) => {
                Object.values(costType).forEach((code) => {
                    jobTotal = jobTotal + pNum(code)
                })
            })
            totals.laborPhased[id] = jobTotal
        })

        Object.keys(equipmentPieces).forEach((id) => {
            const job = equipmentPieces[id]
            let jobTotal = 0
            Object.values(job).forEach((costType) => {
                Object.values(costType).forEach((code) => {
                    jobTotal = jobTotal + pNum(code)
                })
            })
            totals.equipmentCostType[id] = jobTotal
        })

        Object.keys(equipmentPhasedPieces).forEach((id) => {
            const job = equipmentPhasedPieces[id]
            let jobTotal = 0
            Object.values(job).forEach((costType) => {
                Object.values(costType).forEach((code) => {
                    jobTotal = jobTotal + pNum(code)
                })
            })
            totals.equipmentPhased[id] = jobTotal
        })


        projectionCost && projectionCost.forEach((job) => {
            if (!totals.actual[job.Job_Number]) {
                totals.actual[job.Job_Number] = 0
            }
            totals.actual[job.Job_Number] = totals.actual[job.Job_Number] + pNum(job.Total_Job_Cost)
        })

        Object.keys(contingencyPieces).forEach((id) => {
            const job = contingencyPieces[id]
            let jobTotal = 0
            Object.values(job).forEach((costType) => {
                Object.values(costType).forEach((code) => {
                    jobTotal = jobTotal + pNum(code)
                })
            })
            totals.contingency[id] = jobTotal
        })

        Object.keys(etcPieces).forEach((id) => {
            const job = etcPieces[id]
            let jobTotal = 0
            let fieldBonus = 0
            let rentals = 0
            let materials = 0
            let subcontractors = 0
            let other = 0
            Object.keys(job).forEach((costTypeId) => {
                const costType = job[costTypeId]
                Object.values(costType).forEach((code) => {
                    jobTotal = jobTotal + pNum(code)
                    if (costTypeId[0] == '5' && costTypeId[1] == '1' && costTypeId[2] == '8') {
                        fieldBonus = fieldBonus + pNum(code)
                    } if (costTypeId[0] == '5' && costTypeId[1] == '2') {
                        rentals = rentals + pNum(code)
                    } else if (costTypeId[0] == '5' && costTypeId[1] == '3') {
                        materials = materials + pNum(code)
                    } else if (costTypeId[0] == '5' && costTypeId[1] == '4') {
                        subcontractors = subcontractors + pNum(code)
                    } else if (costTypeId[0] == '5' && (costTypeId[1] == '5' || costTypeId[1] == '6' || costTypeId[1] == '7')) {
                        other = other + pNum(code)
                    }
                })
            })
            totals.fieldBonus[id] = fieldBonus
            totals.rentals[id] = rentals
            totals.materials[id] = materials
            totals.subcontractors[id] = subcontractors
            totals.other[id] = other
        })

        filteredJobs.forEach((job, index) => {
            const data = {
                id: job.BU_ID,
                fieldBonus: totals.fieldBonus?.[job.BU_ID] ? fNum(totals.fieldBonus[job.BU_ID]) : 0,
                rentals: totals.rentals?.[job.BU_ID] ? fNum(totals.rentals[job.BU_ID]) : 0,
                materials: totals.materials?.[job.BU_ID] ? fNum(totals.materials[job.BU_ID]) : 0,
                subcontractors: totals.subcontractors?.[job.BU_ID] ? fNum(totals.subcontractors[job.BU_ID]) : 0,
                other: totals.other?.[job.BU_ID] ? fNum(totals.other[job.BU_ID]) : 0,
                etc: totals.etc?.[job.BU_ID] ? fNum(totals.etc[job.BU_ID]) : 0,
                cost: totals.actual?.[job.BU_ID] ? fNum(totals.actual[job.BU_ID]) : 0,
                open: totals.open?.[job.BU_ID] ? fNum(totals.open[job.BU_ID]) : 0,
                contingency: totals.contingency?.[job.BU_ID] ? fNum(totals.contingency[job.BU_ID]) : 0,
                laborCostType: totals.laborCostType?.[job.BU_ID] ? fNum(totals.laborCostType[job.BU_ID]) : 0,
                laborPhased: totals.laborPhased?.[job.BU_ID] ? fNum(totals.laborPhased[job.BU_ID]) : 0,
                equipmentCostType: totals.equipmentCostType?.[job.BU_ID] ? fNum(totals.equipmentCostType[job.BU_ID]) : 0,
                equipmentPhased: totals.equipmentPhased?.[job.BU_ID] ? fNum(totals.equipmentPhased[job.BU_ID]) : 0,
                total: 0
            }

            jobs.push(data)
        })

        //console.log('proj', equipmentPhasedPieces)
        setProjectionDetails(jobs)
    }, [filteredJobs, openCommitmentsPieces, projectionCost, equipmentPieces, equipmentPhasedPieces])

    useEffect(() => {
        let totalJobPerformanceChange = 0
        let totalPrevWIP = 0
        filteredJobs.forEach((job) => {
            const jobPerformanceChange = jobProfit[job.BU_ID] && jobPrevWIP[job.BU_ID]?.total ? pNum(jobProfit[job.BU_ID]) - pNum(jobPrevWIP[job.BU_ID]?.total) + pNum(contingency[job.BU_ID]) - pNum(prevContingency[job.BU_ID]) : 0
            const prevWIP = jobProfit[job.BU_ID] && jobPrevWIP[job.BU_ID]?.total ? pNum(jobProfit[job.BU_ID]) - pNum(jobPrevWIP[job.BU_ID]?.total) : 0
            totalJobPerformanceChange = totalJobPerformanceChange + jobPerformanceChange
            totalPrevWIP = totalPrevWIP + prevWIP
        })
        setTotalJobPerformanceChange(fNum(totalJobPerformanceChange, 1))
        setTotalPrevWIP(fNum(totalPrevWIP, 1))
    }, [jobProfit, jobPrevWIP, contingency, prevContingency])

    const divideIntoSections = (logs) => {
        let sections = [];
        const sectionSize = 31;
        ////console.log('logs', logs, sectionSize)
        for (let i = 0; i < logs.length; i += sectionSize) {
            ////console.log('adding section', logs.slice(i, i + sectionSize))
            sections.push(logs.slice(i, i + sectionSize));
        }
        ////console.log('summary sections', sections)
        return sections;
    }

    // useEffect(() => {
    //     const sortedBacklog = filteredJobs.sort((a, b) => {
    //         const backlogA = backlog[a.BU_ID] || 0;
    //         const backlogB = backlog[b.BU_ID] || 0;

    //         return backlogB - backlogA; // Sort descending
    //     });
    //     setBacklogFiltered(sortedBacklog);
    //     ////console.log('sortedBacklog', divideIntoSections(sortedBacklog))
    //     setBacklogFilteredImage(divideIntoSections(sortedBacklog))
    // }, [filteredJobs, backlog])

    useEffect(() => {
        versions && versions.length > 0 && setVersionInfo(versions.find(v => v.Version_GUID === selectedVersion))
    }, [versions, selectedVersion]);

    useEffect(() => {
        console.log('email', userEmailCheck, allowed[userEmailCheck])
    }, [userEmailCheck]);

    //-------------------


    const Row = ({ v }) => {
        //const [expandCurrentProjections, setExpandCurrentProjections] = useState(false)
        const [highCompare, setHighCompare] = useState(false)

        const handleProjectionsSync = async () => {
            // Per-row sync is handled by bulk CSV flow now
            console.log('Use Generate CSV + Run Bulk Upload buttons instead');
        };


        useEffect(() => {
            const compareValues = (value1, value2) => {
                return Math.abs(pNum(value1) - pNum(value2)) <= 2.00;
            };

            const jobId = v.BU_ID;
            const compareResult =
                compareValues(highLevelCompareList[jobId]?.labor, highLevelCompareList[jobId]?.laborProjection) &&
                compareValues(highLevelCompareList[jobId]?.equipment, highLevelCompareList[jobId]?.equipmentProjection) &&
                compareValues(highLevelCompareList[jobId]?.materials, highLevelCompareList[jobId]?.materialsProjection) &&
                compareValues(highLevelCompareList[jobId]?.subcontractors, highLevelCompareList[jobId]?.subcontractorsProjection) &&
                compareValues(highLevelCompareList[jobId]?.revenue, highLevelCompareList[jobId]?.revenueProjection) &&
                compareValues(highLevelCompareList[jobId]?.contingency, highLevelCompareList[jobId]?.contingencyProjection) &&
                compareValues(highLevelCompareList[jobId]?.other, highLevelCompareList[jobId]?.otherProjection) &&
                compareValues(highLevelCompareList[jobId]?.overhead, highLevelCompareList[jobId]?.overheadProjection);

            setHighCompare(compareResult)
        }, [v.BU_ID, highLevelCompareList]);

        return (

            <View>
                <View style={{ flexDirection: 'row', marginLeft: 10, paddingBottom: 0 }}>
                    {jdeValuesLoading ? <View style={{ marginLeft: 10, width: 10 }}></View> : highCompare ? <View style={{ backgroundColor: 'green', width: 10, marginLeft: 10, borderBottomWidth: 1 }}></View> : <View style={{ backgroundColor: 'yellow', width: 10, marginLeft: 10, borderBottomWidth: 1 }}></View>}
                    {true ? <Pressable
                        style={[s.cell, { width: 30 }]}
                        onPress={() => setExpandCurrentProjections(expandCurrentProjections == v.BU_ID ? '' : v.BU_ID)}>
                        <Icon3 name={expandCurrentProjections == v.BU_ID ? "chevron-down" : "chevron-right"} size={15} color="black" />
                    </Pressable> : <View style={{ width: 30 }}></View>}

                    {/* Projections Sync */}
                    <View style={s.cellNew}>
                        {true ? (
                            projectionsStatus === 'inactive' ? (
                                <View style={[s.iconButton, s.inactive]}>
                                    <Icon name="chart-line" size={16} color="gray" />
                                    <Text style={s.buttonText}>Sync Projection</Text>
                                </View>
                            ) : (
                                <TouchableOpacity style={s.iconButton} onPress={handleProjectionsSync}>
                                    <Icon
                                        name={projectionsStatus === 'match' ? 'sync-alt' : 'exchange-alt'}
                                        size={16}
                                        color={projectionsStatus === 'match' ? 'green' : 'orange'}
                                    />
                                    <Text style={s.buttonText}>Sync Projection</Text>
                                </TouchableOpacity>
                            )
                        ) : (
                            <View style={[s.iconButton, s.inactive]}>
                                <Icon name="chart-line" size={16} color="gray" />
                                <Text style={s.buttonText}>Sync Projection</Text>
                            </View>
                        )}
                    </View>
                    {/* <View style={[s.cellNew, { width: 90 }]}>
                        {budgetStatus === v.BU_ID + 'saved' || savedValues[v.BU_ID] ? (
                            <View style={s.iconButton}>
                                <Icon name="check-circle" size={16} color="green" />
                                <Text style={s.buttonText}>In Sync</Text>
                            </View>
                        ) : budgetStatus === v.BU_ID + 'loading' ? (
                            <View style={s.iconButton}>
                                <ActivityIndicator size="small" color="gray" />
                                <Text style={s.buttonText}>Saving...</Text>
                            </View>
                        ) : <TouchableOpacity style={s.iconButton} onPress={handleProjectionsSync}>
                            <Icon name="sync-alt" size={16} color={notFoundJobs[v.BU_ID] ? 'yellow' : 'green'} />
                            <Text style={s.buttonText}>Sync Projection</Text>
                        </TouchableOpacity>}
                    </View> */}
                    <View style={{ flexDirection: 'row', backgroundColor: 'white' }}>
                        <Text style={[s.cell, { width: 230 }]}>{v.Project_Manager_Name}</Text>
                        <Text numberOfLines={1} style={[s.cell, { width: 200, textAlign: 'left', overflow: 'hidden' }]}>{v.BU_ID} - {v.BU_Description}</Text>
                        <Text numberOfLines={1} style={[s.cell, { width: 100, overflow: 'hidden' }]}>{v.AR_AB_Name}</Text>
                        <Text style={[s.cell, { width: 100 }]}>{totalCost[v.BU_ID] ? (totalCost[v.BU_ID]) : ''}</Text>
                        <Text style={[s.cell, { width: 100 }]}>{ETC[v.BU_ID] ? fNum(ETC[v.BU_ID], 1) : ''}</Text>
                        <Text style={[s.cell, { width: 100 }]}>{EAC[v.BU_ID] ? (EAC[v.BU_ID]) : ''}</Text>
                        <Text style={[s.cell, { width: 100 }]}>{curBudget[v.BU_ID] ? (curBudget[v.BU_ID]) : ''}</Text>
                        <Text style={[s.cell, { width: 100 }]}>{v.profit}</Text>
                        <Text style={[s.cell, { width: 100 }]}>{v.margin}</Text>
                        <Text style={[s.cell, { width: 100 }]}>{v.financialComplete}</Text>
                        <Text style={[s.cell, { width: 100 }]}>{v.billings}</Text>
                        <Text style={[s.cell, { width: 100 }]}>{v.remainingToBill}</Text>
                        <Text style={[s.cell, { width: 100 }]}>{v.overUnderBilled}</Text>
                        <Text style={[s.cell, { width: 100 }]}>{v.billingsCost}</Text>
                        <Text style={[s.cell, { width: 100 }]}>{v.billingComplete}</Text>
                        <Text style={[s.cell, { width: 100 }]}>{v.earnedRevenue}</Text>
                        <Text style={[s.cell, { width: 100 }]}>{v.backlog}</Text>
                    </View>
                </View>
                {expandCurrentProjections == v.BU_ID ? (
                    <View>
                        <View style={{ flexDirection: 'row' }}>
                            <View style={{ margin: 20, backgroundColor: 'white', padding: 20, marginLeft: 150 }}>
                                <Text style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 10 }}>LEMSO Compare List</Text>
                                <View style={{ flexDirection: 'row', paddingVertical: 8, borderBottomWidth: 1, borderColor: '#ddd', backgroundColor: '#e0e0e0' }}>
                                    <Text style={{ width: 200, textAlign: 'center', paddingHorizontal: 5 }}>Category</Text>
                                    <Text style={{ width: 100, textAlign: 'center', paddingHorizontal: 5 }}>JDE</Text>
                                    <Text style={{ width: 100, textAlign: 'center', paddingHorizontal: 5 }}>Fusion</Text>
                                </View>
                                {[
                                    { label: 'Revenue', fusion: fNum(highLevelCompareList[v.BU_ID].revenue), jde: fNum(highLevelCompareList[v.BU_ID].revenueProjection) },
                                    { label: 'Labor', fusion: fNum(highLevelCompareList[v.BU_ID].labor), jde: fNum(highLevelCompareList[v.BU_ID].laborProjection) },
                                    { label: 'Equipment', fusion: fNum(highLevelCompareList[v.BU_ID].equipment), jde: fNum(highLevelCompareList[v.BU_ID].equipmentProjection) },
                                    { label: 'Materials', fusion: fNum(highLevelCompareList[v.BU_ID].materials), jde: fNum(highLevelCompareList[v.BU_ID].materialsProjection) },
                                    { label: 'Subcontractors', fusion: fNum(highLevelCompareList[v.BU_ID].subcontractors), jde: fNum(highLevelCompareList[v.BU_ID].subcontractorsProjection) },
                                    { label: 'Other', fusion: fNum(highLevelCompareList[v.BU_ID].other), jde: fNum(highLevelCompareList[v.BU_ID].otherProjection) },
                                    { label: 'Contingency', fusion: fNum(highLevelCompareList[v.BU_ID].contingency), jde: fNum(highLevelCompareList[v.BU_ID].contingencyProjection) },
                                    { label: 'Overhead', fusion: fNum(highLevelCompareList[v.BU_ID].overhead), jde: fNum(highLevelCompareList[v.BU_ID].overheadProjection) },
                                ].map((row, i) => (
                                    <View key={i} style={{ flexDirection: 'row', paddingVertical: 8, borderBottomWidth: 1, borderColor: '#ddd' }}>
                                        <Text style={{ width: 200, textAlign: 'center', paddingHorizontal: 5 }}>{row.label}</Text>
                                        <Text style={{ width: 100, textAlign: 'center', paddingHorizontal: 5 }}>{row.fusion}</Text>
                                        <Text style={{ width: 100, textAlign: 'center', paddingHorizontal: 5 }}>{row.jde}</Text>
                                    </View>
                                ))}
                            </View>
                        </View>
                        {compareListJob && compareListJob.length > 0 && (
                            <View style={{ flexDirection: 'row' }}>
                                <View style={{ margin: 20, backgroundColor: 'white', padding: 20, marginBottom: 50, marginLeft: 150 }}>
                                    <Text style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 10 }}>Compare List</Text>
                                    <View style={{ flexDirection: 'row', paddingVertical: 8, borderBottomWidth: 1, borderColor: '#ddd', backgroundColor: '#e0e0e0' }}>
                                        <Text style={{ width: 100, textAlign: 'center', paddingHorizontal: 5 }}>Job ID</Text>
                                        <Text style={{ width: 100, textAlign: 'center', paddingHorizontal: 5 }}>Cost Type</Text>
                                        <Text style={{ width: 100, textAlign: 'center', paddingHorizontal: 5 }}>Phase Code</Text>
                                        <Text style={{ width: 100, textAlign: 'center', paddingHorizontal: 5 }}>JDE Value</Text>
                                        <Text style={{ width: 100, textAlign: 'center', paddingHorizontal: 5 }}>Projection Value</Text>
                                    </View>
                                    {compareListJob.map((upload, i) => (
                                        <View key={i} style={{ flexDirection: 'row', paddingVertical: 8, borderBottomWidth: 1, borderColor: '#ddd' }}>
                                            <Text style={{ width: 100, textAlign: 'center', paddingHorizontal: 5 }}>{upload.jobId}</Text>
                                            <Text style={{ width: 100, textAlign: 'center', paddingHorizontal: 5 }}>{upload.costType}</Text>
                                            <Text style={{ width: 100, textAlign: 'center', paddingHorizontal: 5 }}>{upload.phaseCode}</Text>
                                            <Text style={{ width: 100, textAlign: 'center', paddingHorizontal: 5 }}>{upload.value}</Text>
                                            <Text style={{ width: 100, textAlign: 'center', paddingHorizontal: 5, backgroundColor: Math.abs(pNum(upload.value) - pNum(upload.projectionValue)) > 2 ? '#ffcccc' : '' }}>{upload.projectionValue}</Text>
                                        </View>
                                    ))}
                                </View>
                            </View>
                        )}
                    </View>
                ) : null}
            </View>
        )
    }

    const pullAndSaveJobs = async () => {
        console.log('pulling jobs for version', selectedVersion)
        loadJobsNew({ forecastGuid: selectedVersion }).then((data) => {
            console.log('Jobs loaded:', data);
            data?.data?.forEach(job => {
                let data = {
                    userId: '154045',
                    userName: 'Seth Bailey',
                    tab: "Job Info",
                    fieldName: 'info',
                    id: job.BU_ID,
                    value: job.BU_Description,
                    projectStart: job.Actual_Start_Date,
                    projectEnd: job.Actual_Complete_Date,
                    phaseStart: job.Planned_Start_Date,
                    phaseEnd: job.Planned_Complete_Date,
                    status: job.Cat_Code_BU_16,
                    rowLabel: job.Cat_Code_BU_27,
                    notes: job.Cat_Code_BU_18,
                    vendor: job.AR_AB_Name,
                    version: selectedVersion + '',
                    insertRow: 1,
                    description: job.Cat_Code_BU_08,
                    resourceCode: job.Cat_Code_BU_38_Description
                }
                updateUserDataArray(data)
            })
        }).catch(err => {
            console.log('Error loading jobs:', err);
        });
    }

    const syncStatus = async () => {
        console.log('syncing status for CO Log data');

        // Get all job IDs from filtered jobs
        //const jobIds = jobs.map(job => job.BU_ID);
        const jobIds = ['54024100', '54025041', '54025059', '10124013', '11624096', '11624148', '11625086',
 '12024047', '13523007', '13524004', '13524017', '13524016', '13524023', '16123030',
 '50225003', '50225009', '54023048', '54023086', '54023083', '54023091', '54024017',
 '54024037', '54024042', '54024061', '54025025', '54025033', '54025047', '54025060',
 '11624025', '11624369', '11624368', '12425025', '11625005', '12025039', '54025063',
 '50224033', '54024082', '13525006', '12024133', '11625158', '54025032']

        // Load user data for CO Log
        loadTeamUserData({ ids: jobIds, forecastGuid: selectedVersion }).then((data) => {
            console.log('User data loaded for sync:', data);

            // Create object to store CO Log data organized by job and row
            const coLogDataStatus = {}
            const coLogsNull = [];
            const coLogs = {}

            // Process CO Log data
            data?.data?.forEach((d) => {
                if (d?.Forecast_Tab === 'Change Order') {
                    if (!coLogs[d?.BU_ID]) {
                        coLogs[d?.BU_ID] = {}   
                    } 

                    if (!coLogs[d?.BU_ID][d?.Forecast_User_Data_GUID]) {
                        coLogs[d?.BU_ID][d?.Forecast_User_Data_GUID] = []   
                    }
                    coLogs[d?.BU_ID][d?.Forecast_User_Data_GUID].push(d)

                    if (!d.Status) {
                        coLogsNull.push(d)
                    }

                    if (coLogDataStatus[d?.BU_ID] && d.Status?.length) {
                        coLogDataStatus[d?.BU_ID][d?.Forecast_User_Data_GUID] = d.Status
                    } else if (d.Status?.length) {
                        coLogDataStatus[d?.BU_ID] = {
                            [d?.Forecast_User_Data_GUID]: d.Status
                        }
                    }
                }
            });

            console.log('Processed CO Log data:', coLogDataStatus);

            // Array to store update data objects
            const updateDataArrayList = [];

            coLogsNull?.forEach(log => {
                // Map fields using dbFieldMap
                let mappedLog = '';
                if (coLogDataStatus[log.BU_ID] && coLogDataStatus[log.BU_ID][log.Forecast_Row_ID]) {
                    mappedLog = coLogDataStatus[log.BU_ID][log.Forecast_Row_ID];
                }
                //, logs: coLogs[log.BU_ID][log.Forecast_Row_ID]
                updateDataArrayList.push({ jobId: log.BU_ID + '', rowId: log.Forecast_User_Data_GUID + '', status: mappedLog });
            });

            console.log('Update array prepared:', updateDataArrayList);

            // updateDataArrayList.forEach(data => {
            //     if (data.status) {
            //         updateCOStatus(data);
            //     }
            // });

        }).catch(err => {
            console.log('Error loading user data for sync:', err);
            alert('Error syncing status data');
        });
    }

    return (
        <View>
            <View style={{ flexDirection: 'row' }}>
                <View style={{ backgroundColor: 'white', borderRadius: 5, margin: 20, flexDirection: 'row', alignItems: 'center', padding: 10 }}>
                    {versionInfo && versionInfo.Version_Start_DateTime &&
                        <View>
                            <View style={{ backgroundColor: isLiveVersion ? '#192440' : 'white', borderRadius: 5, justifyContent: 'center', padding: 10 }}>
                                <Text style={{ color: isLiveVersion ? 'white' : 'black' }}>
                                    {moment(versionInfo.Version_Start_DateTime).format('MMM D, YYYY')} {isLiveVersion ? '- Active' : ''}
                                </Text>
                            </View>
                        </View>
                    }
                    <Text style={{ fontSize: 16, paddingLeft: 30 }}>
                        {selectedTeam}
                    </Text>
                </View>
                {process.env.NODE_ENV != 'production' ? <View style={{ backgroundColor: 'white', borderRadius: 5, justifyContent: 'center', padding: 10, margin: 20, marginLeft: 20 }}>
                    <Pressable
                        style={{ alignItems: 'center', backgroundColor: '#e0e0e0', padding: 10, borderRadius: 5 }}
                        onPress={() => {
                            setAdminButton(!adminButton)
                        }}
                    >
                        <Text>Load All Teams</Text>
                    </Pressable>
                </View> : null}
                {process.env.NODE_ENV != 'production' ? <View style={{ backgroundColor: 'white', borderRadius: 5, justifyContent: 'center', padding: 10, margin: 20, marginLeft: 20 }}>
                    <Pressable
                        style={{ alignItems: 'center', backgroundColor: '#e0e0e0', padding: 10, borderRadius: 5 }}
                        onPress={() => {
                            pullAndSaveJobs()
                        }}
                    >
                        <Text>Save recent jobs</Text>
                    </Pressable>
                </View> : null}
                {process.env.NODE_ENV != 'production' ? <View style={{ backgroundColor: 'white', borderRadius: 5, justifyContent: 'center', padding: 10, margin: 20, marginLeft: 20 }}>
                    <Pressable
                        style={{ alignItems: 'center', backgroundColor: '#d4edda', padding: 10, borderRadius: 5 }}
                        onPress={() => {
                            syncStatus()
                        }}
                    >
                        <Text>Sync Status</Text>
                    </Pressable>
                </View> : null}
            </View>
            {(process.env.NODE_ENV != 'production' || allowed[userEmailCheck]) && notFoundList && notFoundList.length ? <View style={{ flexDirection: 'row' }}>
                <View style={{ backgroundColor: '#fff', padding: 10, margin: 10, marginLeft: 20 }}>
                    <Pressable
                        style={{ alignItems: 'center', padding: 5, borderRadius: 5, flexDirection: 'row' }}
                        onPress={() => setShowNotFoundList(!showNotFoundList)}
                    >
                        <Icon2
                            name={showNotFoundList ? "expand-less" : "expand-more"}
                            size={20}
                        />
                        <Text style={{ fontSize: 12, marginLeft: 10 }}>Combination String Not Found in GL Account:</Text>
                        <Text style={{ fontSize: 12, marginLeft: 10 }}>{notFoundListCount}</Text>
                    </Pressable>
                    {showNotFoundList ?
                        <View style={{ margin: 20, backgroundColor: 'white', marginBottom: 50 }}>
                            <View style={{ flexDirection: 'row', paddingVertical: 8, borderBottomWidth: 1, borderColor: '#ddd', backgroundColor: '#e0e0e0' }}>
                                <Text style={{ width: 70, fontSize: 12, textAlign: 'center', paddingHorizontal: 5 }}>Tier</Text>
                                <Text style={{ width: 70, fontSize: 12, textAlign: 'center', paddingHorizontal: 5 }}>Job ID</Text>
                                <Text style={{ width: 70, fontSize: 12, textAlign: 'center', paddingHorizontal: 5 }}>Cost Type</Text>
                                <Text style={{ width: 70, fontSize: 12, textAlign: 'center', paddingHorizontal: 5 }}>Phase Code</Text>
                                <Text style={{ width: 70, fontSize: 12, textAlign: 'center', paddingHorizontal: 5 }}>Value</Text>
                                <Text style={{ width: 70, fontSize: 12, textAlign: 'center', paddingHorizontal: 5 }}>New Phase Code</Text>
                            </View>
                            {notFoundList.map((upload, i) => (
                                <View key={i} style={{ flexDirection: 'row', paddingVertical: 8, borderBottomWidth: 1, borderColor: '#ddd', alignItems: 'center' }}>
                                    <Text style={{ width: 70, fontSize: 12, textAlign: 'center', paddingHorizontal: 5 }}>{upload.tier}</Text>
                                    <Text style={{ width: 70, fontSize: 12, textAlign: 'center', paddingHorizontal: 5 }}>{upload.jobId}</Text>
                                    <Text style={{ width: 70, fontSize: 12, textAlign: 'center', paddingHorizontal: 5 }}>{upload.costType}</Text>
                                    <Text style={{ width: 70, fontSize: 12, textAlign: 'center', paddingHorizontal: 5 }}>{upload.phaseCode}</Text>
                                    <Text style={{ width: 70, fontSize: 12, textAlign: 'center', paddingHorizontal: 5 }}>{upload.value}</Text>
                                    {combinationDropdown[upload.jobId]?.[upload.costType] ? <select
                                        style={{ width: 150, border: '1px solid #ccc', borderRadius: 5, paddingLeft: 10, paddingRight: 10, backgroundColor: '#fff', height: 32, fontSize: 12 }}
                                        value={upload.phaseCode}
                                        onChange={(e) => handlePhaseChange(upload, e.target.value)}
                                    >
                                        <option value="">Select Phase</option>
                                        {combinationDropdown[upload.jobId]?.[upload.costType].map((opt) => (
                                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                                        ))}
                                    </select> : <Text>None Available</Text>}
                                    <Text style={{ flex: 2, textAlign: 'center', paddingHorizontal: 5 }}>{upload.message}</Text>
                                </View>
                            ))}
                        </View> : null}
                </View>
            </View> : null}
            {process.env.NODE_ENV != 'production' || allowed[userEmailCheck] ? (
                moment().diff(moment(selectedWIP?.Version_Start_DateTime), 'months') >= 1 && (
                    <View style={{ flexDirection: 'row', marginLeft: 20, marginTop: 20, marginRight: 200 }}>
                        <View style={s.syncBox}>
                            <Text style={s.syncText}>
                                ✅ Projections can be synced for the current WIP period: <Text style={{ fontWeight: 'bold' }}>{selectedWIP?.Version_Start_DateTime ? moment(selectedWIP?.Version_Start_DateTime).add(1, 'month').endOf('month').format('MMMM YYYY') : ''}</Text>
                            </Text>
                        </View>
                        {jdeValuesLoading ? (
                            <View style={[s.syncBox, { marginLeft: 20, backgroundColor: '#e5e7e9', borderColor: '#909497', alignItems: 'center', flexDirection: 'row' }]}>
                                <Text style={{ marginRight: 10 }}>JDE values loading [can take up to a minute]</Text>
                                <ActivityIndicator size="small" color="black" />
                            </View>
                        ) : null}
                    </View>
                )
            ) : null}
            {process.env.NODE_ENV != 'production' || allowed[userEmailCheck] ? (
                moment().diff(moment(selectedWIP?.Version_Start_DateTime), 'months') >= 1 && (
                    <View style={{ flexDirection: 'row', marginLeft: 20, marginTop: 20, marginRight: 200, gap: 10 }}>
                        <Pressable
                            onPress={generateCSV}
                            style={[s.syncBox, { marginLeft: 20, backgroundColor: '#d4f6d1', borderColor: '#7cc67f', alignItems: 'center', flexDirection: 'row' }]}
                        >
                            <Text style={{ marginRight: 10 }}>1. Generate CSV</Text>
                        </Pressable>
                        {submitProjectionsLoading ? <ActivityIndicator size="small" color="black" /> : null}
                        <Pressable
                            onPress={runBulkUpload}
                            style={[s.syncBox, { marginLeft: 10, backgroundColor: '#e5e7e9', borderColor: '#909497', alignItems: 'center', flexDirection: 'row' }]}
                        >
                            <Text style={{ marginRight: 10 }}>2. Run Bulk Upload</Text>
                        </Pressable>
                        {postProjectionsLoading ? <ActivityIndicator size="small" color="black" /> : null}
                    </View>
                )
            ) : null}
            <View style={{ flexDirection: 'row', marginLeft: 20, marginTop: 10, gap: 10 }}>
                <Pressable
                    onPress={generateCSV}
                    style={[s.syncBox, { backgroundColor: '#d4f6d1', borderColor: '#7cc67f', alignItems: 'center', flexDirection: 'row' }]}
                >
                    <Text style={{ marginRight: 10 }}>1. Generate CSV</Text>
                </Pressable>
                <Pressable
                    onPress={runBulkUpload}
                    style={[s.syncBox, { backgroundColor: '#e5e7e9', borderColor: '#909497', alignItems: 'center', flexDirection: 'row' }]}
                >
                    <Text style={{ marginRight: 10 }}>2. Run Bulk Upload</Text>
                </Pressable>
            </View>
            <View style={{ marginBottom: 300 }}>
                <View style={{ flexDirection: 'row', marginLeft: 20, marginTop: 30, marginRight: 200 }}>
                    <Text style={{ width: 30 }}></Text>
                    <Text style={{ width: 100 }}></Text>
                    <View style={{ backgroundColor: 'white', flexDirection: 'row' }}>
                        <View style={[s.cell, { width: 230, height: 64, flexDirection: 'row', alignItems: 'center' }]}>
                            <View>
                                <Text style={{ fontSize: 12 }}>Project Manager</Text>
                                {/*<select
                                    style={{ height: 32, width: 200, borderColor: isFocus ? 'blue' : '#aeadaf', borderWidth: 1, paddingLeft: 8, paddingRight: 8, fontSize: 16 }}
                                    value={pm || ''}
                                    onFocus={() => setIsFocus(true)}
                                    onBlur={() => setIsFocus(false)}
                                    onChange={(e) => {
                                        setPM(e.target.value);
                                        setIsFocus(false);
                                        saveSelectedProjectManager(e.target.value);
                                    }}
                                >
                                    <option value="">Select Project Manager</option>
                                    {pmOptions.map((opt) => (
                                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                                    ))}
                                </select>
                            </View>*/}
                                {/* {pm ? <Icon2 name="clear" size={20} color="black" onPress={() => {
                                setPM()
                                saveSelectedProjectManager('')
                                ////console.log('selectedtema', selectedTeam, jobSections[selectedTeam], jobSections)
                            }} /> : null} */}
                            </View>
                        </View>
                        <Text style={[s.cell, { width: 200, height: 64 }]}>Job</Text>
                        <Text style={[s.cell, { width: 100, height: 64 }]}>Client</Text>
                        <Text style={[s.cell, { width: 100, height: 64 }]}>Current Cost</Text>
                        <Text style={[s.cell, { width: 100, height: 64 }]}>Est. Costs Remaining</Text>
                        <Text style={[s.cell, { width: 100, height: 64 }]}>Est. Costs At Completion</Text>
                        <Text style={[s.cell, { width: 100, height: 64 }]}>Contract Value</Text>
                        <Text style={[s.cell, { width: 100, height: 64 }]}>Profit</Text>
                        <Text style={[s.cell, { width: 100, height: 64 }]}>Margin</Text>
                        <Text style={[s.cell, { width: 100, height: 64 }]}>Financial % Complete</Text>
                        <Text style={[s.cell, { width: 100, height: 64 }]}>Billings</Text>
                        <Text style={[s.cell, { width: 100, height: 64 }]}>Remaining to Bill</Text>
                        <Text style={[s.cell, { width: 100, height: 64 }]}>Over/(Under) Billed</Text>
                        <Text style={[s.cell, { width: 100, height: 64 }]}>Billings-Cost</Text>
                        <Text style={[s.cell, { width: 100, height: 64 }]}>Billing % Complete</Text>
                        <Text style={[s.cell, { width: 100, height: 64 }]}>Earned Revenue</Text>
                        <Text style={[s.cell, { width: 100, height: 64 }]}>Backlog</Text>
                    </View>
                </View>
                {filteredJobs.map((v, i) => (
                    <Row key={i} v={v} />
                ))}
            </View>
        </View>
    );
}





export default Projections;

